export default {
	italian: "Italiano",
	english: "Inglese",
	japanese: "Giapponese",
	french: "Francese",
	german: "Tedesco",
	spanish: "Spagnolo",
	pause_game: "Pausa gioco",
	resume_game: "Riprendi gioco",
	map_config: {
		select: "Configurazione mappa",
		none: "Nessuna configurazione",
		save: "Salva configurazione",
		load: "Carica configurazione",
		save_new: "Crea nuova configurazione",
		save_overwrite: "Sovrascrivi esistente",
		save_mode: "Modalità di salvataggio",
		name: "Nome della configurazione",
		name_optional: "Nuovo nome (opzionale)",
		name_placeholder: "Es: Centro storico",
		keep_name: "Verrà mantenuto il nome: {name}",
		overwrite_warning: "La configurazione selezionata verrà sovrascritta. Questa azione non può essere annullata.",
		load_warning: "La configurazione attuale della mappa verrà sovrascritta con quella selezionata.",
		locked_center: "Il punto iniziale è bloccato dalla configurazione della mappa selezionata.",
		no_template: "Seleziona un modello per gestire le configurazioni della mappa.",
		saved: "Configurazione salvata correttamente",
		loaded: "Configurazione caricata correttamente",
		save_error: "Impossibile salvare la configurazione",
		load_error: "Impossibile caricare la configurazione",
		loading_map: "Caricamento mappa...",
		disabled_event_started: "Non è possibile modificare la configurazione con l'evento avviato"
	},
	preview: {
		common_sense: {
			title: "Anteprima del Buon Senso",
			open_preview: "Anteprima",
			unsaved_warning: "Questa anteprima mostra modifiche della bozza che non sono ancora state salvate.",
			start_game: "Inizia gioco",
			spin_roulette: "Gira ruota",
			show_rules: "Mostra regole",
			next_phase: "Fase successiva",
			finish_challenge: "Termina sfida",
			show_final_ranking: "Classifica finale",
			show_challenge_ranking: "Classifica della sfida",
			show_result: "Mostra risultato",
			back_to_roulette: "Torna alla ruota",
			back_to_waiting_room: "Torna alla sala d'attesa",
			resume_game: "Riprendi gioco",
			collapse_controls: "Nascondi controlli",
			expand_controls: "Mostra controlli",
			hint_explorer: "Modalità esploratore: spostati tra gli schermi.",
			hint_game_flow: "Modalità gioco: seleziona una sfida e segui il flusso di gioco.",
			hint_select_round: "Seleziona una sfida e, se vuoi, un potenziatore per configurare ogni round dell'anteprima.",
			hint_collapse: "Puoi nascondere questo pannello con la freccia per vedere lo schermo del giocatore a schermo intero. Riaprilo quando vuoi con il pulsante flottante.",
			tutorial_step_explorer: "Passo 1 · Modalità esploratore",
			tutorial_step_game: "Passo 2 · Modalità gioco",
			tutorial_step_select: "Passo 1 · Sfida e potenziatore",
			tutorial_step_collapse: "Passo 2 · Nascondi controlli",
			tutorial_finish: "Finalizza",
			dismiss_hints: "Capito",
			tutorial_live_sync_title: "Anteprima dal vivo",
			tutorial_live_sync_text: "Le modifiche che apporti al modello si aggiornano automaticamente in questa anteprima. Non è necessario ricaricare la pagina: modifica e controlla il risultato immediatamente.",
			jump_to_phase: "Salta alla fase",
			step_waiting: "Sala d'attesa",
			step_roulette: "Roulette",
			step_rules: "Regole",
			step_play: "Sfida",
			step_result: "Risultato",
			step_challenge_ranking: "Classifica sfida",
			step_final_ranking: "Classifica finale"
		}
	},
	general: {
		are_you_sure: "Sei sicuro?",
		preview_not_able: "Impossibile visualizzare questo contenuto",
		gateway_preview_language: "Lingua",
		gateway_preview_settings: "Impostazioni",
		download: "Scarica",
		budget: "Budget",
		download_pdf: "Scarica PDF",
		download_image: "Scarica immagine",
		play_video: "Riproduci video",
		slides: "Diapositive",
		change: "Cambia",
		wrong_link: "Il link non è valido o è scaduto, per favore contatta la persona che ti ha inviato il link.",
		test_speed: "Prova Velocità",
		testing_speed: "Prova in corso...",
		speed_test_results: "Risultati del test di velocità",
		speed_test_failed: "Errore durante la prova della velocità",
		unable_to_complete_speed_test: "Impossibile completare il test di velocità. Per favore riprova.",
		excellent_speed: "Eccellente velocità!",
		good_speed: "Buona velocità!",
		slow_speed: "Velocità lenta!",
		your_connection_is_very_fast: "La tua connessione è molto veloce!",
		your_connection_is_decent: "La tua connessione è decente!",
		your_connection_needs_improvement: "La tua connessione ha bisogno di miglioramenti!",
		test_audio: "Prova audio",
		testing_audio: "Riproduzione audio in corso...",
		stop_audio: "Fermare audio",
		audio_test_results: "Risultati del test audio",
		audio_test_success: "Se hai sentito il suono, l'audio funziona correttamente.",
		audio_test_failed: "Errore durante il test audio",
		unable_to_complete_audio_test: "Impossibile riprodurre l'audio. Controlla il volume e i permessi del dispositivo.",
		join: "Unirsi",
		point_gain: "Punti guadagnati",
		point_loss: "Punti persi",
		accept_event: "Vuoi accettare questo evento?",
		reject: "Rifiuta",
		one_vs_all_questions: "Domande 1 vs tutti",
		question: "Domanda",
		history: "Storia",
		acceptAll: "Accetta tutti",
		delivered: "Consegnato",
		pending: "In attesa",
		close: "Chiudi",
		collabo_title: "Applicazione di Collaborazione",
		copy_link: "Copia link",
		go_to_link: "Vai al link",
		enter_team_name: "Inserisci il nome del team",
		organizer_options: "Opzioni dello staff",
		staff_warning: "Non toccare nulla se non sei un membro dello staff",
		accept: "Accetta",
		not_answered: "Non risposto",
		name_company: "Teaming App",
		back: "Indietro",
		go: "Vai",
		select: "Seleziona",
		next: "Prossimo",
		team: "Squadra",
		teams: "Squadre",
		round: "Turno",
		ranking: "Classifica",
		results: "Risultati",
		total: "Totale",
		remaining: "Rimanente",
		round_remaining: "Turno rimanente",
		answer: "Rispondere",
		units: "Unità",
		shop: "Negozio",
		ingredients: "Ingredienti",
		rices: "Risi",
		plates: "Piatti",
		choosing: "Scegliendo",
		save: "Salva",
		saved: "Salvato",
		cancel: "Annulla",
		name: "Nome",
		buy: "Acquista",
		photo: "Foto",
		redo: "Ripeti",
		password: "Password",
		exit: "Esci",
		canceled: "Annullato",
		event: "Evento",
		day: "Giorno",
		ingredient: "Ingrediente",
		points: "Punti",
		position: "Posizione",
		agency: "Distribuitore",
		delete: "Elimina",
		updated: "aggiornato",
		created: "creato",
		update: "aggiorna",
		create: "crea",
		filters: "Filtri",
		apply_filters: "Applica filtri",
		clear_filters: "Pulisci filtri",
		search: "Cerca",
		add: "Aggiungi",
		start: "Inizia",
		from: "Fino a",
		error: "Errore",
		chat: "Chat",
		game_master: "STAFF",
		options: "Opzioni",
		reactions: "Reazioni",
		team_name: "Nome della squadra",
		option_organizer: "Opzioni staff",
		btn_send_answer: "Invia risposta",
		btn_continue: "Continua",
		correct_answer: "Risposta corretta",
		incorrect_answer: "Risposta scorretta",
		challenge_complete: "Sfida completata",
		instructor: "Istruttore",
		edit: "Modifica",
		unsaved_changes: "Ci sono modifiche non salvate",
		en: "Inglese",
		es: "Spagnolo",
		yes: "Sì",
		no: "No",
		ipad_title: "App Caccia al Tesoro",
		tapas_title: "App Culinarie",
		utq_title: "App Rally",
		action_title: "App Contest e App Costruzione",
		cluedo_ai_title: "Applicazione di Investigazione",
		bingo_title: "App Bingo Musicale",
		common_sense_title: "Applicazione Common Sense",
		hours: "Ore",
		minutes: "Minuti",
		new: "Nuovo",
		mark_all_read: "Segna tutto come letto",
		name_app: "APP TEAMING",
		hello: "Ciao",
		reload_app: "Ricarica APP",
		change_monitor: "Cambia monitor",
		must: "Obbligatorio",
		first: "Primo",
		you: "Tu",
		try_again: "Errore, riprova",
		incorrect_fields: "Ci sono campi errati nel modulo",
		save_changed: "Modifica salvata",
		ranking_block: "L'amministratore ha nascosto il ranking",
		ranking_hidden: "Il ranking è nascosto",
		ranking_display: {
			normal: "Normale",
			cooperative: "Cooperativo",
			both: "Entrambi",
			hidden: "Nascosto",
			slides: "Diapositive"
		},
		answer_correct: "Risposta corretta",
		answer_incorrect: "Risposta incorretta",
		pair_a: "Coppia A ",
		pair_b: "Coppia B ",
		order_colon: "Ordine: ",
		quiz_multi: "Questionario multiplo",
		answer_auto: "Risposta autocorretta",
		order: "Ordine",
		click_add: "Clicca per aggiungere",
		click_upload: "Clicca per caricare",
		upload: "Caricare",
		uploading: "Caricamento in corso...",
		quiz: "Questionario",
		pairs: "Coppie",
		min_answers: "Deve esserci un minimo di {min} risposte",
		max_answers: "Il limite di risposte è {max}",
		file_large: "Il file è troppo pesante, il massimo è 50MB",
		new_item: "Nuovo elemento",
		new_contact: "Nuovo contatto",
		add_item: "Aggiungi un elemento",
		add_contact: "Aggiungi un contatto",
		missing_items: "Non ci sono elementi aggiunti",
		missing_contacts: "Non ci sono contatti aggiunti",
		select_item: "Seleziona un elemento",
		select_contact: "Seleziona un contatto",
		total_price: "Totale {total_price}€",
		app_activity_plus: "+ App Attività",
		app_activity: "App Attività",
		url_admin: "URL dashboard",
		url_gm: "URL Monitor",
		preview: "Anteprima",
		actions: "Azioni",
		challenges: "Sfidare",
		all: "Tutti",
		demo_upper: "DEMO",
		demo_mode: "Modalità demo",
		start_demo_mode: "Iniziare modalità demo",
		stop_demo_mode: "Fermare modalità demo",
		demo_mode_title: "Iniziare modalità demo",
		demo_mode_stop_title: "Fermare modalità demo",
		demo_mode_info_duration: "La modalità demo avrà una durata massima di 30 minuti.",
		demo_mode_info_alert: "I giocatori riceveranno un avviso che indica che sono in modalità demo.",
		demo_mode_info_reset: "Tutti i contenuti generati durante la demo saranno cancellati.",
		demo_mode_info_stop: "La demo potrà essere interrotta manualmente dallo stesso pulsante.",
		demo_mode_time_left: "Tempo rimanente della demo: {time}",
		demo_mode_confirm_start: "Inizia demo",
		demo_mode_confirm_stop: "Ferma demo e riavvia",
		demo_mode_started: "Modalità demo avviata",
		demo_mode_stopped: "Modalità demo interrotta e partita riavviata",
		demo_mode_banner: "Stai giocando in modalità demo. I progressi verranno cancellati.",
		demo_mode_active: "La modalità demo è attiva",
		invalid_url: "L'URL non è valido",
		open: "Apri",
		chat_with_gm: "Chatta con il monitor",
		cluedo_ai_act: "Applicazione di Ricerca",
		submit: "Invia",
		not_started: "Il gioco non è ancora iniziato",
		no_picture: "Nessuna foto di squadra",
		upload_team_picture: "Foto di squadra",
		plates_rices: "Piatti/Risi",
		done: "Superato",
		challenge: "Reto",
		no_data: "Nessun dato",
		link_monitors: "Collegare Facilitatori"
	},
	join_lobby: {
		title: "Unirsi al lobby",
		subtitle: "Inserisci il tuo nome e attendi che il personale crei le squadre.",
		enable: "Attiva JoinLobby",
		demo_disabled: "JoinLobby non può essere attivato negli eventi demo.",
		use_locations: "Usa posizioni",
		locations_before_link_hint: "Assicurati che le posizioni siano configurate correttamente prima di condividere il link del lobby con i giocatori.",
		locations: "Posizioni",
		locations_placeholder: "Scrivi una posizione e premi invio",
		location: "Posizione",
		location_placeholder: "Seleziona la tua posizione",
		name_placeholder: "Inserisci il tuo nome",
		join_lobby: "Unisciti al lobby",
		waiting_staff: "Sei nel lobby. Lo staff creerà le squadre presto.",
		players_online: "Giocatori online",
		no_location: "Nessuna posizione",
		join_random_team: "Unisciti a una squadra casuale",
		staff_title: "Impostazioni JoinLobby",
		lobby_link: "Link del lobby",
		players_per_team: "Giocatori per squadra",
		players_per_team_location: "Giocatori per squadra ({location})",
		teams: "Squadre",
		total_players: "Totale giocatori",
		total_players_with_count: "Totale giocatori: {count}",
		total_teams_with_count: "Totale squadre: {count}",
		teams_will_be_created: "Saranno create {count} squadre",
		teams_already_created_message: "Le squadre sono già state create. I giocatori possono già unirsi a una squadra casuale utilizzando l'URL del lobby qui sopra.",
		create_teams: "Crea squadre",
		teams_created: "Squadre create",
		button_tooltip: "Permette ai giocatori di unirsi alle attività e poi formare le squadre"
	},
	analytics: {
		feedback_tab: "Feedback",
		budget_tab: "Budget",
		events_tab: "Eventi",
		budget_coming_soon: "Pagina del budget (prossimamente)",
		number_of_events: "Numero di eventi",
		total_eur: "Totale €",
		mean_eur_event: "Media € Evento",
		mean_eur_teambuilding_event: "Media € Evento Teambuilding",
		mean_pax_event: "Media Pax Evento",
		show_plot_1: "Mostra Grafico 1",
		show_plot_2: "Mostra Grafico 2",
		month_1: "Gennaio",
		month_2: "Febbraio",
		month_3: "Marzo",
		month_4: "Aprile",
		month_5: "Maggio",
		month_6: "Giugno",
		month_7: "Luglio",
		month_8: "Agosto",
		month_9: "Settembre",
		month_10: "Ottobre",
		month_11: "Novembre",
		month_12: "Dicembre",
		number_of_budget: "Numero di budget",
		number_of_closed_budget: "Numero di budget chiusi",
		number_of_lost_budget: "Numero di budget persi",
		percent_of_closed_budget: "% di budget chiusi",
		number_of_open_budget: "Numero di budget aperti",
		number_of_won_budget: "Numero di budget vinti",
		all_months: "Tutti i mesi",
		anual_income: "Reddito annuale",
		type_of_activity: "Attività",
		type_of_event_budget: "Tipo di evento",
		euro_event: "€ Evento",
		euro_extra: "€ Extra",
		event_place: "Luogo dell'evento",
		review_summary: "Riepilogo delle recensioni",
		total_events: "Totale eventi",
		events_with_reviews: "Eventi con recensioni",
		review_rate: "Tasso di recensioni",
		category_averages: "Medie per categoria",
		review_details: "Dettagli delle recensioni",
		expectations: "Aspettative",
		scale: "Scala",
		game_masters: "Game Masters",
		content: "Contenuto",
		service_prices: "Servizio/Prezzi",
		organization: "Organizzazione",
		hire_again: "Assumere di Nuovo",
		reviews: "recensioni",
		event_id: "ID dell'Evento",
		activity: "Attività",
		overall_scale: "Scala Generale",
		stars: "stelle"
	},
	menu: {
		analytics: "Analytics",
		sales: "Vendite",
		budgets: "Budget",
		clients: "Clienti",
		bookings: "Prenotazioni",
		booking_list: "Elenco delle prenotazioni",
		calendar: "Calendario",
		summaries: "Riepiloghi",
		activities: "Attività",
		demos: "Dimostrazioni",
		content: "Contenuto",
		settings: "Impostazioni",
		settings_erp: "Configurazione",
		organization: "Organizzazione",
		activities_erp: "Catalogo",
		event_service: "Servizi per eventi",
		extras: "Pagina extra",
		final_page_budget: "Pagina finale budget",
		activities_questions: "Domande sulla prenotazione",
		credits_consumption: "Consumo di crediti",
		superadmin: "Superadmin",
		superadmin_credits: "Crediti (tutte le org)",
		superadmin_organization_stats: "Statistiche per org",
		favorite_photos: "Foto preferite",
		app_personalization: "Personalizzazione dell'app",
		integrations: "Integrazioni",
		add_staff: "Aggiungi monitor",
		my_activities: "Le mie attività",
		staff: "Monitor",
		notifications: "Notifiche",
		changelog: "Novità",
		logout: "Disconnetti",
		switch_organization_label: "Organizzazione attiva",
		switch_organization_confirm_title: "Cambiare organizzazione?",
		switch_organization_confirm_message: "Stai per lavorare come \"{name}\". La pagina si ricaricherà e potresti perdere ciò che non è stato salvato.",
		switch_organization_confirm: "Cambia",
		switch_organization_error: "Impossibile cambiare organizzazione"
	},
	superadmin: {
		credits: {
			title: "Crediti di tutte le organizzazioni",
			subtitle: "Raggruppa i consumi per mese per fatturare e annullare partite di test",
			filters: "Filtri",
			organization: "Organizzazione",
			organization_filter_mode: "Modalità org",
			organization_include: "Includi selezionate",
			organization_exclude: "Escludi selezionate",
			all_organizations: "Tutte le organizzazioni",
			year: "Anno",
			month: "Mese",
			status: "Stato",
			apply: "Applica",
			total_lines: "Righe",
			total_credits: "Crediti",
			total_amount: "Importo",
			monthly_summary: "Riepilogo mensile",
			rows_count: "{count} periodi",
			empty_state: "Nessun consumo con questi filtri",
			empty_lines: "Nessuna riga in questo periodo",
			col_organization: "Organizzazione",
			col_period: "Periodo",
			col_lines: "Righe",
			col_credits: "Crediti",
			col_amount: "Importo",
			col_status: "Stato",
			col_actions: "Azioni",
			col_date: "Data",
			col_event: "Partita",
			col_activity: "Attività",
			view_lines: "Vedi righe",
			ensure_batch: "Crea lotto",
			ensure_batches_all: "Crea lotti (tutti)",
			batches_ensured_all: "Lotti pronti: {count} (falliti: {failed})",
			batches_ensured_partial: "Alcuni lotti non sono riusciti ({failed})",
			mark_invoiced: "Fatturato",
			mark_paid: "Pagato",
			mark_voided: "Annulla lotto",
			manual_invoice: "Fattura manuale",
			manual_invoice_dialog_title: "Fattura manuale",
			manual_invoice_dialog_intro:
				"Il periodo {org} · {period} sarà segnato come fatturato senza inviarlo a Holded.",
			manual_invoice_reference: "Riferimento fattura (opzionale)",
			manual_invoice_reference_placeholder: "Es. FAT-2026-001",
			manual_invoice_confirm: "Segna come fatturato",
			manual_invoice_success: "Fattura manuale registrata ({org} · {period})",
			send_holded: "Holded",
			holded_soon: "Integrazione Holded in arrivo",
			holded_create: "Crea in Holded",
			holded_approve: "Approva Holded",
			holded_send: "Invia email",
			holded_send_invoice: "Invia fattura Holded",
			holded_create_and_email: "Crea + email",
			holded_approve_and_email: "Crea + approva + email",
			holded_already_sent: "Inviata a Holded",
			holded_create_email_dialog_title: "Crea fattura e invia email",
			holded_create_email_dialog_intro: "Verrà creata la fattura in Holded (bozza) e inviata via email.",
			holded_send_dialog_title: "Invia fattura con Holded",
			holded_send_dialog_intro: "La fattura di questo periodo di crediti verrà creata, approvata e inviata in Holded.",
			holded_flow_create_email: "Crea + email: genera la bozza in Holded e invia l'email (senza approvare).",
			holded_flow_approve_email: "Crea + approva + email: genera, approva e invia la fattura completa.",
			holded_send_dialog_step_create: "Verrà creata la fattura in Holded con i crediti del periodo.",
			holded_send_dialog_step_approve: "La fattura verrà approvata automaticamente.",
			holded_send_dialog_step_email: "Verrà inviata un'email automaticamente all'organizzazione ({org} · {period}).",
			holded_send_dialog_note: "Usa l'email di fatturazione configurata sull'organizzazione. Verifica ID Holded e billing mail.",
			holded_will_send_to: "L'email verrà inviata a: {email}",
			holded_contact_ok: "Holded contact ID configurato: {id}",
			holded_missing_billing_mail: "Impossibile inviare: all'organizzazione manca billing_mail.",
			holded_missing_contact: "Impossibile inviare: all'organizzazione manca holded_contact_id.",
			holded_error_approve: "Errore nell'approvazione Holded: {error}",
			holded_error_send: "La fattura è stata creata ma l'email non è stata inviata: {error}",
			holded_send_confirm: "Invia fattura",
			holded_create_and_email_confirm: "Crea e invia",
			holded_approve_and_email_confirm: "Crea, approva e invia",
			holded_create_email_success: "Bozza creata e inviata a {email} (Holded {id})",
			holded_send_invoice_success: "Fattura approvata e inviata a {email} (Holded {id})",
			holded_create_success: "Bozza Holded creata ({id})",
			holded_approve_success: "Fattura approvata in Holded",
			holded_send_success: "Fattura inviata via email",
			void_event: "Annulla partita",
			void_line: "Annulla riga",
			unvoid_line: "Ripristina",
			save_line: "Salva",
			save_line_success: "Riga aggiornata",
			lines_locked_holded: "Questo periodo è già stato inviato a Holded. Le righe non possono essere modificate o annullate.",
			before_void: "prima dell'annullamento",
			void_line_confirm: "Annullare questa riga di crediti?",
			void_line_success: "Riga annullata",
			unvoid_line_success: "Riga ripristinata",
			no_event: "Senza partita",
			void_confirm: "Annullare tutti i crediti di \"{name}\"? Usa questa azione per rimuovere i test.",
			void_success: "Annullate {count} righe",
			batch_ensured: "Lotto mensile pronto",
			status_updated: "Stato aggiornato",
			load_failed: "Impossibile caricare il riepilogo crediti",
			load_lines_failed: "Impossibile caricare le righe",
			action_failed: "Impossibile completare l'azione",
			status_pending: "In sospeso",
			status_invoiced: "Fatturato",
			status_paid: "Pagato",
			status_voided: "Annullato",
			month_1: "Gennaio",
			month_2: "Febbraio",
			month_3: "Marzo",
			month_4: "Aprile",
			month_5: "Maggio",
			month_6: "Giugno",
			month_7: "Luglio",
			month_8: "Agosto",
			month_9: "Settembre",
			month_10: "Ottobre",
			month_11: "Novembre",
			month_12: "Dicembre",
		},
		organization_stats: {
			title: "Statistiche per organizzazione",
			subtitle: "Crediti ed euro venduti, e attività fatte (senza annullati). Filtra per organizzazione e periodo.",
			filters: "Filtri",
			hint_individual: "Dettaglio dell'organizzazione selezionata. Le linee annullate sono escluse.",
			hint_compare: "Totali di tutte le organizzazioni filtrate. Selezionane una per il dettaglio.",
			back_to_comparison: "Torna al confronto",
			organization: "Organizzazione",
			organizations: "Organizzazioni",
			organization_filter_mode: "Modalità org",
			organization_include: "Includi selezionate",
			organization_exclude: "Escludi selezionate",
			year: "Anno",
			month: "Mese",
			all_months: "Tutti i mesi",
			apply: "Applica",
			totals: "Totali",
			select_organization: "Seleziona un'organizzazione",
			empty_state: "Nessun dato di crediti per questi filtri",
			diff_title: "A vs B",
			chart_monthly_credits: "Crediti venduti per mese",
			chart_monthly_euros: "Euro venduti per mese",
			chart_monthly_activities: "Attività fatte per mese",
			chart_activities: "Top attività per crediti",
			chart_intensity_activities: "Intensità: crediti per attività",
			chart_compare_ranking: "Ranking crediti per organizzazione",
			chart_compare_intensity: "Intensità: crediti per attività",
			chart_compare_monthly: "Trend mensile crediti per organizzazione",
			chart_compare_activity_mix: "Mix attività per organizzazione",
			table_compare: "Confronto affiancato",
			col_metric: "Metrica",
			col_totals: "Totali",
			kpi_credits: "Crediti venduti",
			kpi_credit_amount: "Euro venduti",
			kpi_events: "Attività fatte",
			kpi_activities: "Tipi di attività",
			kpi_lines: "Linee di credito",
			kpi_credits_per_event: "Crediti / attività",
			kpi_avg_amount_per_event: "€ / attività",
			metric_credits: "Crediti venduti",
			metric_credit_amount: "Euro venduti",
			metric_events: "Attività fatte",
			metric_activities: "Tipi di attività",
			metric_lines: "Linee di credito",
			metric_credits_per_event: "Crediti / attività",
			metric_avg_amount_per_event: "€ / attività",
			visible_rows: "Righe visibili",
			only_with_data: "Solo organizzazioni con dati",
			series_credits: "Crediti venduti",
			series_credit_amount: "Euro venduti",
			series_events: "Attività fatte",
			series_credits_per_event: "Crediti / attività",
			insight_concentration: "Le 3 attività principali ({activities}) concentrano il {percent}% dei crediti",
			load_failed: "Impossibile caricare le statistiche",
		},
	},
	changelog: {
		title: "Novità",
		subtitle: "Ultime aggiornamenti e miglioramenti dell'app",
		empty: "Non ci sono novità pubblicate.",
		new: "Nuovo",
		mark_read: "Segna come letto",
		mark_all_read: "Segna tutto come letto",
		view_all: "Vedi tutto",
		got_it: "Capito",
		dismiss: "Chiudi"
	},
	notifications: {
		empty: "Non ci sono notifiche"
	},
	budgets: {
		currency: "Valuta",
		type: "Tipo",
		activities: "Attività",
		budget_description: "Descrizione del budget",
		placeholder_budget_description: "Descrizione del budget",
		budgets: "Budget",
		status: "Stato",
		search: "Cerca",
		search_name: "Cerca per nome",
		name: "Nome",
		client: "Cliente",
		people: "Persone",
		date: "Data dell'evento",
		open: "Aperto",
		won: "Vinto",
		lost: "Perso",
		all: "Tutti",
		new_budget: "Nuovo Budget",
		must_name: "Deve avere un nome",
		budget_validity: "Validità del budget",
		hour: "Ora",
		show_total: "Mostra totale",
		language: "Lingua",
		spanish: "Spagnolo",
		english: "Inglese",
		catalan: "Catalano",
		conditions: "Condizioni",
		extras: "Extra",
		budget: "Budget",
		close_budget: "Chiudi Budget",
		download: "Scarica",
		select_option: "Seleziona un'opzione",
		select_items: "Seleziona gli articoli da trasferire nella riserva",
		comments_close_budget: "Commenti sulla chiusura del budget",
		convert: "Convertire",
		close: "Chiudere",
		back: "Torna",
		cancel: "Annulla",
		line: "Aggiungi riga",
		line_type: "Linea",
		category: "Categoria",
		budget_type: "Tipo di Budget",
		auto_price: "Prezzo Automatico",
		total: "Totale",
		description: "Descrizione",
		price_tag: "Tag prezzo",
		pax: "Persone",
		price: "Prezzo",
		user: "Utente",
		no_condition: "Senza condizioni",
		comments: "Commenti Interni",
		activity: "Attività",
		location: "Posizione",
		item: "Elemento",
		first: "Primo",
		close_convert: "Chiudi/Converti budget",
		comments_budget: "Aggiungi commenti al budget",
		bulk_add_button: "Aggiungi più attività",
		bulk_add_title: "Aggiungi più attività",
		bulk_select_categories: "Seleziona le categorie di attività",
		bulk_categories_placeholder: "Seleziona categorie...",
		bulk_or_search_activities: "Oppure salta le categorie e cerca in tutto il catalogo.",
		bulk_browse_all_activities: "Cerca in tutte le attività",
		bulk_select_activities_all: "Cerca e seleziona attività in tutto il catalogo",
		bulk_no_activities_loaded: "Non ci sono attività disponibili da aggiungere",
		bulk_select_activities: "Seleziona le attività che vuoi aggiungere",
		bulk_no_activities: "Non ci sono attività nelle categorie selezionate",
		bulk_search_activities_placeholder: "Cerca per nome o codice...",
		bulk_no_activities_search: "Nessuna attività corrisponde alla ricerca",
		bulk_pax_hint: "Indica il numero di persone per le {count} attività selezionate",
		bulk_default_price_tag: "Etichetta di prezzo predefinita",
		bulk_default_price_tag_placeholder: "Seleziona un'etichetta di prezzo...",
		bulk_default_price_tag_none: "Senza etichetta predefinita",
		bulk_next: "Successivo",
		bulk_add_confirm: "Aggiungi al budget"
	},
	bookingmedia: {
		uploadImages: "Carica immagini",
		downloadImages: "Scarica immagini",
		imagesUploaded: "Immagine caricata",
		imageRemoved: "Immagine rimossa",
		uploadFailed: "Errore nel caricamento dell'immagine",
		uploadAllFailed: "Non è stato possibile caricare alcuna immagine. Controlla la connessione e riprova.",
		uploadPartialSuccess: "Sono state caricate {success} di {total} immagini. {failed} non sono riuscite a essere caricate.",
		uploadRetrying: "Riprovo ({attempt}/{max})",
		notSavedForm: "Devi salvare la prenotazione prima di caricare le immagini",
		imageUploaded: "Immagine caricata",
		uploadedImage: "Immagine della prenotazione",
		viewImage: "Vedi immagine ingrandita",
		removeImage: "Rimuovi immagine",
		removeFailed: "Non sono riuscito a rimuovere l'immagine",
		noImages: "Non ci sono ancora foto",
		noImagesHint: "Carica immagini per documentare la prenotazione",
		photoCount: "{count} foto(e)",
		loadMorePhotos: "Carica di più ({count} rimanenti)",
		noContent: "Non ci sono immagini da scaricare"
	},
	favoritePhotos: {
		title: "Foto preferite",
		subtitle: "Foto salvate delle prenotazioni, filtrate per prenotazione e attività",
		addFavorite: "Aggiungi ai preferiti",
		removeFavorite: "Rimuovi dai preferiti",
		selectActivity: "Assegna attività",
		selectActivityHint: "Per impostazione predefinita viene selezionata la prima attività della prenotazione. Puoi cercare e scegliere qualsiasi attività dal catalogo.",
		searchActivity: "Cerca attività...",
		searchBooking: "Cerca prenotazione...",
		noFilterResults: "Nessun risultato",
		previousPhoto: "Foto precedente",
		nextPhoto: "Foto successiva",
		downloadError: "Impossibile scaricare l'immagine",
		selectActivityPlaceholder: "Seleziona un'attività",
		noActivitySearchResults: "Non sono state trovate attività",
		noActivitiesCatalog: "Non ci sono attività nel catalogo",
		noActivitiesInBooking: "Questa prenotazione non ha attività associate. La foto sarà salvata senza attività.",
		activity: "Attività",
		noActivity: "Senza attività",
		added: "Foto aggiunta ai preferiti",
		removed: "Foto rimossa dai preferiti",
		addError: "Impossibile aggiungere ai preferiti",
		removeError: "Impossibile rimuovere dai preferiti",
		filterBooking: "Prenotazione",
		filterActivity: "Attività",
		allBookings: "Tutte le prenotazioni",
		allActivities: "Tutte le attività",
		applyFilters: "Filtra",
		empty: "Non ci sono foto preferite ancora",
		loadingMore: "Caricamento di altre foto…",
		allPhotosLoaded: "Sono state mostrate {count} foto"
	},
	bookings: {
		file: "File",
		activity_sheet: "Scheda dell'attività",
		staff_document: "Documento per il personale",
		responsible: "Responsabile",
		crm_id: "ID CRM",
		placeholder_crm_id: "ID CRM",
		pipedrive_deal_search_placeholder: "Cerca deal in Pipedrive…",
		pipedrive_open_deal: "Apri in Pipedrive",
		pipedrive_loading_deal: "Caricamento deal Pipedrive…",
		pipedrive_deal_not_found: "Deal non trovato in Pipedrive",
		pipedrive_deal_load_error: "Impossibile caricare il deal di Pipedrive",
		pipedrive_invalid_deal_id: "L'ID CRM non è un ID deal Pipedrive valido",
		staff_main: "Responsabile di produzione",
		gm_rejected: "Monitori rifiutati",
		accepted: "Stato",
		history_status_pending: "In attesa",
		history_status_saved: "Salvato",
		history_author: "Autore",
		history_source_client: "Cliente",
		history_source_staff: "Personale",
		history_applied: "Applicato",
		history_field_booking_item: "Entrate",
		history_field_cost_item: "Spese",
		history_field_game_master_record: "Monitor",
		file_archive_title: "Archivio documenti",
		file_archive_file: "Archivio",
		file_archive_section: "Sezione",
		file_archive_status: "Stato",
		agent_suggestions: "Agente IA",
		agent_suggestions_title: "Agente IA",
		agent_suggestions_hint: "L'agente esamina i dati della prenotazione e, se collegato, il deal di Pipedrive e il relativo thread email.",
		agent_suggestions_loading: "Analisi della prenotazione...",
		agent_suggestions_refresh: "Analizza di nuovo",
		agent_priority_high: "Alta",
		agent_priority_medium: "Media",
		agent_priority_low: "Bassa",
		agent_pipedrive_included: "Dati Pipedrive inclusi",
		agent_pipedrive_not_included: "Nessun deal Pipedrive (non collegato o CRM ID mancante)",
		agent_pipedrive_emails_included: "{count} email del deal analizzate",
		agent_pipedrive_emails_empty: "Nessuna email collegata al deal",
		agent_pipedrive_emails_error: "Impossibile leggere le email del deal",
		agent_open_deal: "Apri deal",
		agent_pipedrive_notes: "Note CRM",
		agent_field_hint: "Campo",
		agent_no_pending: "Nessun elemento in sospeso rilevato.",
		agent_disabled: "L'agente non è attivo per questa organizzazione.",
		agent_error: "Impossibile ottenere i suggerimenti.",
		file_archive_active: "Attivo",
		file_archive_removed: "Rimosso",
		media_files: "Multimedia",
		owner: "Proprietario",
		communication_platform: "Piattaforma di comunicazione",
		communication_url: "URL di comunicazione",
		zoom: "Zoom",
		ms_teams: "MSTeams",
		webex: "Webex",
		google_meet: "GMeet",
		general: "Generale",
		event: "Evento",
		activity_information: "Informazioni sull'attività",
		questions: "Domande",
		economics: "Economia",
		ratings: "Valutazioni",
		bookings: "Prenotazioni",
		media: "Media",
		name: "Nome",
		placeholder_name: "Nome",
		alert_name: "Deve avere un nome",
		client: "Cliente",
		people: "Persone",
		pax_tooltip: "Il numero di partecipanti verrà chiuso 10 giorni prima dell'evento",
		date: "Data",
		search_name: "Cerca per nome",
		search: "Cerca",
		new_booking: "Nuova Prenotazione",
		language: "Lingua",
		hour: "Ora attività",
		client_logo: "Logo del cliente",
		logo_client_tooltip: "In quelle attività che includono supporto digitale e tecnologico (tablet, schermo, cellulare o computer), verrà incorporato il logo che verrà caricato in questa sezione.",
		billing_data: "Dati di fatturazione (Nome azienda, NIF e indirizzo)",
		billing_data_tooltip: "CIF e indirizzo fiscale. Una volta completati i dati di fatturazione, riceverai la fattura corrispondente. Il pagamento integrale del costo dei servizi deve essere effettuato almeno prima dell'evento.",
		activities_app: "Attività App",
		type_event: "Tipo di evento",
		place: "Ubicazione",
		url_location: "Link GMaps",
		place_information: "Informazioni sullo spazio",
		place_information_tooltip: "C'è qualcos'altro che dobbiamo sapere dello spazio?",
		location: "Posizione",
		must_name: "Deve avere un nome",
		general_information: "Informazioni generali",
		company_name: "Nome dell'azienda",
		company_name_tooltip: "Persona responsabile il giorno dell'evento",
		event_general_timing: "Orario generale dell'evento",
		timetable_plain_tooltip: "Indica l'orario dettagliato dell'evento (inizio, pause, pasti, attività, conclusione...).",
		extra_information: "Informazioni extra",
		extra_information_internal: "Informazioni extra interne",
		timeline: "Orario",
		description: "Descrizione",
		add_activity: "Aggiungi attività",
		save_before_add_activity: "Devi salvare il modulo prima di aggiungere attività.",
		number_teams: "Numero di squadre",
		team_number_tooltip: "Il numero di squadre potrebbe variare in base al numero finale dei partecipanti per garantire il corretto svolgimento dell'attività",
		staff_people: "Nº di monitor",
		teams: "Squadre",
		staff: "Monitor",
		add_team: "Aggiungi squadra",
		add_staff: "Aggiungi monitor",
		contact_person: "Persona di contatto",
		add_person_contact: "Aggiungi persona di contatto",
		add_item: "Aggiungi un item",
		new_contact: "Nuovo contatto",
		add_questions: "Aggiungi domande",
		modify_questions: "Modifica domande",
		add: "Aggiungi",
		all_questions: "Tutte le domande",
		activity_questions: "Domande della prenotazione",
		costs: "Costi",
		price: "Prezzo",
		activity: "Attività",
		activities: "Attività",
		activity_ies: "Attività/e",
		reserve_item: "Servizi",
		gm_pay: "Costi dello staff",
		add_gm: "Aggiungi Master",
		game_master: "Master",
		monitor_info: "Info del master",
		no_visible_monitor_fields: "Non ci sono informazioni visibili per questo master",
		salary: "Stipendio",
		total: "Totale",
		gm_valoration: "Valutazione del master",
		client_valoration: "Valutazione del cliente",
		es: "Spagnolo",
		en: "Italiano",
		cat: "Catalano",
		email: "Email",
		phone: "Telefono",
		extra: "Extra",
		online: "Online",
		in_person: "In persona",
		booking_activities: "Attività App",
		name_place: "Nome del posto",
		direction_location: "Indirizzo url del sito",
		add_cost: "Aggiungi costo",
		add_field: "Aggiungi campo",
		review_gm_enjoy: "I partecipanti si sono divertiti?",
		review_gm_size: "Come valuti la dimensione del team di monitoraggio?",
		review_gm_previous_info: "Come valuti le informazioni antecedenti all'attività?",
		review_gm_started: "Quando è iniziata l'attività?",
		review_gm_material: "È stato danneggiato o perso qualche materiale?",
		review_gm_comments: "Commenti o incidenti?",
		staff_comments: "Commenti",
		review_expectations: "Fino a che punto i nostri servizi hanno soddisfatto le tue aspettative?",
		review_scale: "Da 1 a 10, quanto è probabile che tu raccomandi i nostri servizi a qualcuno del tuo giro?",
		review_gamemasters: "Come valuteresti l'attenzione dei dinamizzatori durante l'attività?",
		review_content: "Come valuteresti il contenuto dell'attività?",
		review_service_prices: "Come valuteresti il prezzo dei servizi?",
		review_previous_organization: "Come valuteresti l'organizzazione precedente all'attività?",
		review_hire_again: "Quali sono le probabilità che tu riutilizzi il nostro servizio?",
		review_comments: "Hai qualche commento o suggerimento per noi?",
		expected_not: "Non hanno soddisfatto le mie aspettative",
		expected_more: "Mi aspettavo di più",
		expected_fulfilled: "Hanno soddisfatto quello che mi aspettavo",
		expected_exceeded: "Hanno superato le mie aspettative",
		very_unsatisfactory: "Molto insoddisfacente",
		unsatisfactory: "Insoddisfacente",
		neutral: "Neutra",
		satisfactory: "Soddisfacente",
		very_satisfactory: "Molto soddisfacente",
		no_complaints: "No, ci sono state molte lamentele",
		standing_group: "Non molto, gruppo fermo",
		generally_yes: "Generalmente sì",
		highly_motivated: "Sì, gruppo molto motivato",
		staff_shortage_critic: "Mancava personale in modo critico",
		staff_shortage: "Mancava personale per andare comodamente",
		correct: "Corretto",
		staff_excess: "C'era personale in eccesso",
		missing_information: "Mancava informazione importante",
		missing_details: "Mancavano dettagli",
		enough: "Sufficiente",
		surplus: "Di troppo",
		early_expected: "Più presto del previsto",
		on_point: "In punto",
		ten_late: "0-10 min in ritardo",
		thirty_late: "10-30 min in ritardo",
		more_late: "+30 min in ritardo",
		user: "Utente",
		timetable: "Orario",
		fundae: "FUNDAE",
		fundae_question: "Volete bonificare questa attività per FUNDAE? Chi la gestisce?",
		fundae_option_no: "No",
		fundae_option_organization: "Sì, lo gestisce {name}",
		fundae_option_client: "Sì, lo gestisce il cliente",
		files_fundae_client: "Documentazione FUNDAE (da compilare per il cliente)",
		files_fundae_client_by_client: "CLIENTE FUNDAE — Documentazione FUNDAE (da compilare per il cliente)",
		files_fundae_staff_tooltip: "Carica qui il contratto di incarico debitamente compilato e firmato. Anche l'elenco dei partecipanti compilato.",
		files_fundae_staff: "Documentazione FUNDAE (Compilata per il cliente)",
		final_client_section: "Cliente finale / Intermediario",
		final_client_section_tooltip: "Se l'attività è rivolta al vostro team, per favore selezionate l'opzione «Cliente finale». Se invece l'attività è per uno dei vostri clienti (ad esempio, se siete un'agenzia, una consulenza, uno spazio o un intermediario), selezionate l'opzione «Intermediario» e rispondete alle domande corrispondenti.",
		final_client_selector: "Sei cliente finale o intermediario?",
		final_client_option_client: "Cliente finale",
		final_client_option_agency: "Intermediario",
		final_client_name: "Nome del cliente finale",
		final_client_agency: "Nome dell'intermediario",
		final_client_white_label: "Il team di facilitazione può presentarsi con abbigliamento aziendale o preferite che l'intervento venga realizzato in formato white label?",
		bill_sent: "Fattura inviata",
		custom_fields_section: "Campi personalizzati",
		contract_section: "Contratto",
		contract_status: "Contratto",
		contract_status_missing_data: "Dati mancanti",
		contract_status_pending_client: "In attesa del cliente",
		contract_status_pending_signature: "Da firmare",
		contract_status_signed: "Firmato",
		contract_status_inactive: "Non attivato",
		contract_status_signed_hidden: "Firmato (non attivato)",
		contract_missing_keys: "Variabili mancanti",
		contract_not_activated_title: "Contratto non attivato",
		contract_not_activated_hint: "Il contratto non è attivato in questa prenotazione. Attivalo così il cliente può vederlo e firmarlo.",
		contract_show_to_client: "Attiva contratto",
		contract_hide_from_client: "Disattiva contratto",
		contract_show_to_client_success: "Contratto attivato",
		contract_hide_from_client_success: "Contratto disattivato",
		contract_reset: "Reimposta contratto",
		contract_reset_confirm: "Verranno eliminati la firma, il PDF firmato e tutti i campi compilati dal cliente. Il cliente potrà compilare e firmare di nuovo. Vuoi continuare?",
		contract_reset_success: "Contratto reimpostato",
		contract_hint_pending_client: "Il cliente può già vedere il contratto nel suo link e compilare i suoi campi.",
		contract_hint_pending_signature: "Tutto pronto. Il cliente può firmare dal suo link o scaricare il PDF.",
		contract_hint_signed: "Il contratto è già firmato. Puoi scaricarlo dal menu ⋮.",
		contract_download_pdf: "Scarica contratto PDF",
		contract_download_signed: "Scarica contratto firmato",
		contract_fill_client_fields_hint: "Compila i campi evidenziati nel contratto. Potrai firmare quando saranno completi.",
		contract_fill_required_before_next: "Devi compilare tutti i campi prima di passare alla firma.",
		contract_fill_required_before_sign: "Devi completare il nome, i campi obbligatori e la firma prima di firmare.",
		contract_sign_choose_option: "Scegli una delle due opzioni per firmare il contratto: firma sul web oppure scaricalo e caricalo.",
		contract_sign_web: "Firma sul web",
		contract_signer_name: "Nome del firmatario",
		contract_clear_signature: "Cancella firma",
		contract_sign: "Firma contratto",
		contract_sign_cta: "Firma contratto",
		contract_continue: "Continua contratto",
		contract_view: "Vedi contratto",
		contract_minimize: "Riduci",
		contract_save_and_continue: "Salva e continua alla firma",
		contract_finish_go_booking: "Termina e vai alla prenotazione",
		contract_upload_signed: "Carica contratto firmato",
		contract_upload_signed_hint: "Scarica il PDF, firmalo e caricalo qui.",
		contract_upload: "Carica PDF",
		contract_upload_pdf_only: "Sono consentiti solo file PDF",
		contract_signed_success: "Contratto firmato correttamente",
		filter_contract_status_label: "Stato del contratto",
		filter_contract_status_description: "Filtra le prenotazioni per stato del contratto",
		contract_var_name: "Nome della prenotazione",
		contract_var_date: "Data",
		contract_var_time: "Ora",
		contract_var_pax: "Persone",
		contract_var_language: "Lingua",
		contract_var_type: "Tipo (online/presenziale)",
		contract_var_activity_duration: "Durata",
		contract_var_place_name: "Luogo",
		contract_var_place_url: "URL del luogo",
		contract_var_place_info: "Info del luogo",
		contract_var_place_contact: "Contatto del luogo",
		contract_var_billing_data: "Dati di fatturazione",
		contract_var_extra_info: "Info extra",
		contract_var_timetable_plain: "Orario",
		contract_var_team_number: "Numero di squadre",
		contract_var_contact_persons: "Persone di contatto",
		contract_var_activities: "Attività (economics)",
		contract_var_total_price: "Prezzo totale (economics)",
		contract_var_budget_number: "Numero di preventivo",
		contract_var_client_name: "Nome del cliente",
		contract_var_client_email: "Email del cliente",
		contract_var_signed_date: "Data di firma",
		contract_var_signed_time: "Ora di firma",
		client_information: "Informazioni del cliente",
		app: "App",
		event_details: "Dettagli dell'evento",
		staff_persons: "Personale",
		incomes: "Entrate",
		valoration_available: "VALUTAZIONE (disponibile al termine dell'evento)",
		very_likely: "Molto probabile",
		likely: "Probabile",
		unlikely: "Poco probabile",
		very_unlikely: "Molto improbabile",
		close_booking: "Chiudi Prenotazione",
		agency_files: "File interni",
		client_files: "File del cliente",
		client_files_tooltip: "Qualsiasi file necessario per la realizzazione dell'evento, come la lista dei partecipanti, orari o altra documentazione rilevante.",
		invoice_files: "File di fattura",
		event_invoice_files: "Fatture delle spese dell'evento",
		upload_expense_invoice: "Carica fattura delle spese",
		upload_expense_invoice_modal_title: "Carica fattura delle spese",
		upload_expense_invoice_modal_hint: "Puoi caricare una o più fatture delle spese dell'evento. Non potrai vedere le fatture caricate da qui.",
		add_file: "Aggiungi file",
		price_tag: "Tag prezzo",
		item: "Voce di prenotazione",
		line: "Linea",
		pax: "Persone",
		auto_price: "Prezzo automatico",
		done: "Completato",
		canceled: "Annullato",
		open: "Aperto",
		add_question_warning: "Le domande che aggiungi non saranno tradotte",
		place_contact: "Contatto del luogo",
		place_contact_tooltip: "Indica i dettagli di contatto della persona responsabile presso il luogo dell'evento (reception, responsabile del luogo, ecc.).",
		detail_canceled: "ANNULLATA",
		detail_open: "APERTA",
		detail_closed: "CHIUSA",
		status: "Stato",
		filter_dialog_title: "Filtra prenotazioni",
		filter_state_label: "Stato della prenotazione",
		filter_state_description: "Mostra solo prenotazioni negli stati selezionati (aperta, completata o cancellata).",
		filter_owner_label: "Responsabile della prenotazione",
		filter_owner_description: "Filtra per la persona responsabile della prenotazione.",
		filter_main_staff_label: "Responsabile di produzione",
		filter_main_staff_description: "Filtra per il responsabile di produzione assegnato alla prenotazione.",
		filter_fundae_label: "Sovvenzione FUNDAE",
		filter_fundae_description: "Se la prenotazione ha FUNDAE attivo (gestito dall'organizzazione o dal cliente).",
		filter_fundae_files_label: "Documentazione FUNDAE (Compilata per il cliente) (2+ file)",
		filter_fundae_files_description: "Mostra prenotazioni che hanno almeno due file caricati nella documentazione FUNDAE compilata per il cliente.",
		filter_bill_sent_label: "Fattura inviata",
		filter_bill_sent_description: "Se la fattura è stata contrassegnata come inviata per la prenotazione.",
		filter_language_label: "Lingua dell'evento",
		filter_language_description: "Lingua configurata per la prenotazione dell'evento."
	},
	activities: {
		activities: "Attività",
		activity: "App",
		game: "App",
		day: "Giorno",
		enter: "Entra",
		create_activity: "Crea Attività",
		sure: "Sei sicuro?",
		delete: "Elimina",
		date_hour: "Data e ora",
		name_activity: "Nome dell'attività",
		type_activity: "App",
		language: "Lingua",
		comments: "Commenti",
		logo: "Logo",
		demo: "Demo",
		demo_locked_tooltip: "Una volta creato l'evento, non è possibile passare alla demo né rimuovere la demo.",
		alert_name_activity: "Inserisci un nome per l'attività.",
		select_language: "Seleziona una lingua",
		select_challenge: "Seleziona una sfida",
		select_date: "Seleziona una data",
		select_activity: "Seleziona un tipo di attività",
		select_name: "Inserisci un nome per l'attività",
		select_primary_color: "Seleziona un colore primario.",
		select_secondary_color: "Seleziona un colore secondario.",
		save_error: "Impossibile {message_request_negative} l'evento",
		save_ok: "Evento {message_request} correttamente",
		delete_error: "Impossibile eliminare l'evento",
		delete_ok: "È stato eliminato l'evento",
		tl_activity: "Attività {company}",
		click_add: "Clicca per Aggiungere",
		dashboard: "Dashboard"
	},
	demos: {
		demos: "Demos",
		create_demo: "Crea Demo"
	},
	content: {
		collabo: {
			presets: "Preset",
			preset: "Preset",
			challenges: "Sfide",
			challenge: "Sfida",
			challenges_placeholder: "Seleziona sfide",
			videos: "Video Collabo",
			video_item: "Video Collabo",
			videos_placeholder: "Seleziona video",
			videos_title: "Titolo",
			description_gm: "Descrizione (GM)",
			video: "Video",
			challenge_type: "Tipo di sfida",
			challenge_type_placeholder: "Seleziona tipo di sfida",
			name: "Nome",
			material: "Materiale",
			materials: "Materiali",
			materials_placeholder: "Seleziona materiali",
			construction: "Costruzione",
			constructions: "Costruzioni",
			constructions_placeholder: "Seleziona costruzioni",
			model3d: "Modello 3D",
			paint: "Pitturare",
			statment: "Dichiarazione",
			make: "Fare",
			find: "Trova",
			find_missing: "Trova mancante",
			image: "Immagine",
			subcontent: "Subcontenuto",
			subcontent_placeholder: "es., city_find, flower_pattern",
			description: "Descrizione",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			placeholder_description: "Descrizione della sfida..."
		},
		content: "Contenuto",
		add_new_content: "Nuovo",
		discard_and_new_content: "Le modifiche non salvate andranno perse. Vuoi creare un nuovo contenuto?",
		list_content: "Elenco dei contenuti",
		no_template: "Senza modello",
		no_act: "Senza caso",
		all: "Tutti",
		downloading_content: "Download in corso",
		skip_download: "Continua senza aspettare",
		skip_download_hint:
			"Puoi continuare ora. Il resto verrà scaricato in background quando c'è connessione.",
		background_download_remaining: "{count} rimanenti",
		background_download_in_settings: "Download dei contenuti rimanenti…",
		exporting_event_content: "Esportando invii dei giocatori",
		files_remaining: "file rimanenti",
		export_transferring_zip: "Avvio download...",
		export_uploading_s3: "Caricamento ZIP su storage...",
		export_ready_downloading: "ZIP pronto, avvio download...",
		export_download_button: "Scarica ZIP",
		player_asset_cache_title: "Preparazione contenuti offline",
		player_asset_cache_text: "Salvataggio mappe e file sul tuo dispositivo per poterli utilizzare offline.",
		cluedo_ai: {
			cluedo_ai_settings: "Impostazioni Cluedo AI",
			cluedo_ai_setting: "Impostazione Cluedo AI",
			cluedo_ai_title: "Cluedo AI",
			cluedo_ai_act: "Caso",
			cluedo_ai_questions: "Domande",
			cluedo_ai_objects: "Oggetti",
			cluedo_ai_characters: "Personaggi",
			cluedo_ai_object: "Oggetto",
			cluedo_ai_character: "Personaggio",
			cluedo_ai_question: "Domanda",
			duration: "Durata",
			placeholder_duration: "Durata dell'attività",
			image_quiz: "Immagine quiz",
			image1: "Immagine 1",
			image2: "Immagine 2",
			image3: "Immagine 3",
			description: "Descrizione",
			placeholder_description: "Descrizione dell'attività",
			name: "Nome",
			placeholder_name: "Nome dell'attività",
			id_name: "Nome identificativo",
			placeholder_id_name: "Nome identificativo dell'attività",
			alert_id_name: "Inserisci un nome identificativo per l'attività",
			templates: "Modelli",
			act: "Caso",
			no_act: "Senza caso",
			setting: "Impostazioni",
			character: "Personaggio",
			questions: "Domande",
			no_character: "Senza personaggio",
			no_questions: "Senza domande",
			key_information: "Informazioni chiave",
			placeholder_key_information: "Informazioni chiave",
			placeholder_prompt: "Invito",
			placeholder_prompt_answer: "Risposta all'invito",
			placeholder_question: "Domanda",
			placeholder_answer: "Risposta",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			question: "Domanda",
			answer: "Risposta",
			prompt_answer: "Prompt di Risposta",
			points: "Punti",
			act_char: "Personaggio",
			image: "Immagine",
			model3d: "Modello 3D",
			prompt: "Prompt",
			start_message: "Messaggio di avvio",
			placeholder_start_message: "Messaggio di avvio",
			background: "Sfondo",
			add_key_information: "Aggiungi informazioni chiave",
			age: "Età",
			placeholder_age: "Età del personaggio",
			job: "Lavoro",
			placeholder_job: "Lavoro del personaggio",
			personal_information: "Informazioni personali",
			placeholder_personal_information: "Informazioni personali del personaggio",
			personality: "Personalità",
			placeholder_personality: "Personalità del personaggio",
			context: "Contesto",
			placeholder_context: "Contesto del personaggio",
			case_related: "Caso correlato",
			placeholder_case_related: "Caso correlato del personaggio",
			motivation: "Motivazione",
			placeholder_motivation: "Motivazione del personaggio",
			previous_knowledge: "Conoscenze pregresse",
			placeholder_previous_knowledge: "Conoscenze pregresse del personaggio",
			relashionship: "Relazioni",
			placeholder_relashionship: "Relazioni del personaggio",
			description_player: "Descrizione del personaggio",
			placeholder_description_player: "Descrizione del personaggio",
			short_text: "Testo breve"
		},
		ipad: {
			ipad_settings: "Impostazioni Ipad",
			ipad_setting: "Impostazione Ipad",
			ipad_challenges: "Sfide digitali",
			must: "Obbligatorio",
			optional: "Opzionale",
			first: "Primo",
			content_list: "Elenco dei contenuti",
			name: "Nome",
			setting: "Impostazioni",
			type: "Template",
			quiz: "Questionario",
			open_text: "Testo libero",
			photo: "Foto",
			video: "Video",
			alert: "Avviso",
			team_photo: "Foto di squadra",
			order: "Ordine",
			match: "Partita",
			type_challenge: "Tipo di sfida",
			id_name: "Nome identificativo",
			password: "Password",
			time: "Tempo",
			challenge_close_time: "Tempo di chiusura",
			max_points: "Punti massimi",
			template: "Template",
			description: "Descrizione",
			file_1: "File 1",
			file_2: "File 2",
			file_3: "File 3",
			placeholder_type: "Seleziona un tipo",
			alert_type: "Seleziona un tipo di sfida",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Dammi un nome identificativo per la sfida.",
			placeholder_name: "Nome della sfida...",
			placeholder_password: "Password...",
			placeholder_description: "Descrizione della sfida...",
			expected_answer: "Risposta Attesa",
			placeholder_expected_answer: "Risposta attesa",
			challenge: "Sfida digitale",
			placeholder_team: "Squadra..",
			challenge_close_time_tooltip: "Secondi minimi prima di poter premere Continua e chiudere la prova.",
		},
		tapas: {
			tapas_settings: "Impostazioni Tapas",
			tapas_setting: "Impostazione Tapas",
			change_time: "Modifica tempo",
			tapas_challenges: "Sfide culinarie",
			tapas_challenge: "Sfida culinaria",
			ingredients: "Ingredienti",
			ingredient: "Ingrediente",
			item_shop: "Negozio",
			item_shop_item: "Negozio",
			name: "Nome",
			type: "Tipo",
			quiz: "Questionario",
			challenge: "Sfida",
			type_challenge: "Tipo di sfida",
			id_name: "Nome Identificativo",
			money: "Denaro",
			template: "Modello",
			image: "Immagine",
			description: "Descrizione",
			placeholder_type: "Seleziona un tipo",
			alert_type: "Seleziona un tipo di sfida",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Metti un nome identificativo alla sfida.",
			placeholder_name: "Nome della sfida...",
			placeholder_description: "Descrizione della sfida...",
			setting: "Impostazioni",
			main_ingredient: "Ingrediente principale",
			secondary_ingredient: "Ingrediente secondario",
			decoration: "Decorazione",
			base: "base",
			quantity: "Quantità",
			quantity_placeholder: "Quantità, Es: 1 pacchetto 200gr...",
			objects_per_team: "Oggetti per numero di squadre",
			once_per_team: "Solo un acquisto per squadra",
			object_shop: "Oggetto Negozio",
			challenge_shop: "Rif shop"
		},
		utq: {
			challenges_utq: "Rally challenges",
			name: "Nome",
			placeholder_name: "Nome della sfida...",
			id_name: "Nome Identificativo",
			material: "Materiale",
			placeholder_material: "Materiale...",
			description: "Descrizione",
			placeholder_description: "Descrizione della sfida...",
			description_score: "Descrizione Punteggio",
			placeholder_description_score: "Descrizione del punteggio della sfida...",
			image: "Immagine",
			quiz: "Questionario",
			challenge: "Sfida rally",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			placeholder_descriptVideoinitial_challengesion_score: "Descrizione del punteggio della sfida..."
		},
		action: {
			action_settings: "Impostazioni",
			action_setting: "Impostazione",
			quiz: "Questionario",
			category_quiz: "Categoria Questionario",
			category_quiz_item: "Categoria Questionario",
			challenge: "Reto",
			challenge_item: "Reto",
			challenges: "Sfide",
			name: "Nome",
			category: "Categoria",
			type: "Tipo",
			setting: "Modello",
			init_challenge: "Sfida iniziale",
			init_challenges: "Sfide iniziali",
			order: "Ordinamento",
			match: "Abbinamento",
			quiz_multi: "Questionario a risposta multipla",
			text_auto: "Risposta autocorretta",
			text_data: "Testo per correzione manuale",
			text_data_auto: "Testo per correzione automatica",
			type_challenge: "Tipo di sfida",
			placeholder_type: "Seleziona un tipo",
			alert_type: "Seleziona un tipo di sfida",
			id_name: "Nome identificativo",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			placeholder_name: "Nome della sfida...",
			description: "Descrizione",
			placeholder_description: "Descrizione della sfida...",
			image_quiz: "Immagine quiz",
			max_money: "Denaro massimo",
			need_material: "Materiale necessario",
			material: "Materiale",
			placeholder_material: "Materiale necessario...",
			expected_answer: "Risposta attesa",
			placeholder_expected_answer: "Risposta attesa",
			file_1: "File 1",
			file_2: "File 2",
			action_challenge_quiz: "Questionario",
			photo: "Foto",
			video: "Video",
			team_photo: "Foto squadra",
			template: "Modello",
			max_points: "Punti massimi",
			cost: "Costo",
			video_duration: "Durata video",
			short_description: "Descrizione breve",
			placeholder_short_description: "Descrizione breve...",
			help_gm: "Aiuto per la punteggiatura",
			help_file: "Immagine soluzione",
			internal_description: "Descrizione interna",
			placeholder_internal_description: "Descrizione della sfida interna...",
			object_shop: "Oggetto Negozio",
			object_shop_item: "Oggetto Negozio",
			challenge_shop: "Negozio Sfida",
			challenge_shop_item: "Negozio Sfida"
		},
		actionChallengeShopItem: {
			one_per_team: "Uno per team",
			two_per_team: "Due per team",
			one_per_two_teams: "Uno ogni due team",
			one_per_three_teams: "Uno per tre team",
			identifying_name: "Nome Identificativo",
			identifying_name_placeholder: "Nome identificativo del questionario...",
			identifying_name_alert: "Inserisci un nome identificativo per il questionario.",
			image: "Immagine",
			cost: "Costo",
			max_per_team: "Massimi per team",
			template: "Modello",
			default_material: "Material predefinito",
			material_description: "Descrizione del materiale",
			name: "Nome",
			name_placeholder: "Nome della sfida...",
			description: "Descrizione",
			description_placeholder: "Descrizione della sfida..."
		},
		bingo: {
			image_challenge_1: "Immagine della sfida 1",
			image_challenge_2: "Immagine della sfida 2",
			image_post_1: "Immagine del post 1",
			image_post_2: "Immagine del post 2",
			challenge_song: "Canzone della sfida",
			winning_song: "Canzone vincente",
			bingo_challenges: "Sfide Bingo Musicale",
			bingo_challenge: "Sfida Bingo Musicale",
			bingo_songs: "Canzoni",
			bingo_song: "Canzone",
			bingo_sets: "Set",
			quiz: "Questionario",
			poll: "Sondaggio",
			two_vs_two: "2 vs 2",
			challenge_type: "Tipo di sfida",
			set: "Set",
			one_vs_all: "1 vs tutti",
			image: "Immagine",
			fill: "Riempi",
			photo: "Foto",
			song_image: "Immagine della canzone",
			set_image: "Immagine del set",
			song_file: "File della canzone",
			challenge: "Sfide (si giocheranno in ordine)",
			song_artist: "Artista",
			song_artist_placeholder: "Artista della canzone..."
		},
		common_sense: {
			challenges: "Sfide Common Sense",
			challenge: "Sfida Common Sense",
			name: "Nome",
			settings: "Modelli Common Sense",
			setting: "Modello Common Sense",
			id_name: "Nome identificativo",
			name_placeholder: "Nome...",
			name_alert: "Aggiungi un nome.",
			primary_color: "Colore principale",
			personalization: "Personalizzazione",
			theme: "Tema",
			challenges_title: "Sfide",
			client_personalization: "Personalizzazione cliente",
			font_family: "Font",
			client_language: "Lingua del cliente",
			background_image: "Immagine di sfondo",
			event_logo: "Logo dell'evento",
			theme_editable: "Tema modificabile",
			questions_editable: "Domande modificabili",
			questions_choose: "Domande selezionabili",
			flow_mode_enabled: "Flusso attivato di default",
			flow_order: "Ordine di default del Flusso",
			flow_order_hint: "Seleziona prima le sfide del modello e poi trascinale qui per definire l'ordine di default.",
			challenge_type: "Tipo di sfida",
			challenge_type_alert: "Seleziona un tipo di sfida.",
			time_results: "Tempo dei risultati",
			questions: "Domande",
			quiz: "Quiz",
			fair_prize: "Prezzo giusto",
			timeline: "Timeline",
			questions_editor: {
				questions_count: "{type} · {count} domande",
				apply_time_to_all: "Applica tempo a tutte",
				add_question: "Aggiungi domanda",
				no_questions_readonly: "Questa sfida non ha domande.",
				no_questions_empty: "Aggiungi la prima domanda a questa sfida Common Sense.",
				question_label: "Domanda",
				answers_title: "Risposte (la prima è quella corretta)",
				add_answer: "Aggiungi risposta",
				correct_answer_placeholder: "Risposta corretta",
				incorrect_answer_placeholder: "Risposta errata {n}",
				fair_prize_correct_answer: "Risposta corretta",
				min_slider: "Minimo dello slider",
				max_slider: "Massimo dello slider",
				interval: "Intervallo",
				order_hint_start: "Indicazione di ordine (inizio — sinistra / primo)",
				order_hint_end: "Indicazione di ordine (fine — destra / ultimo)",
				order_hint_start_placeholder: "es. Più antico, Su, Primo",
				order_hint_end_placeholder: "es. Più recente, Giù, Ultimo",
				order_hint_help: "Viene mostrato ai giocatori a ciascuna estremità della linea temporale per sapere come ordinare (es. antico → recente o sopra → sotto).",
				correct_order: "Ordine corretto",
				add_item: "Aggiungi elemento",
				timeline_item_placeholder: "Elemento {n}",
				image: "Immagine",
				image_optional: "Immagine (opzionale)",
				question_image: "Immagine della domanda",
				upload_image: "Carica immagine",
				remove: "Rimuovi",
				question_header: "Domanda {n}",
				question_added: "Domanda aggiunta",
				time_updated: "Tempo aggiornato"
			}
		}
	},
	settings: {
		settings: "Modelli",
		settings_list: "Elenco dei modelli",
		ipad: {
			name: "Nome",
			id_name: "Nome identificativo",
			placeholder_name_id: "Nome identificativo della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			main_color: "Colore principale",
			secondary_color: "Colore secondario",
			stopwatch_color: "Colore cronometro",
			background_image: "Immagine di sfondo",
			event_logo: "Logo dell'evento",
			points_icon: "Icona dei punti",
			challenges: "Sfide",
			challenge: "Modello"
		},
		tapas: {
			name: "Nome",
			id_name: "Nome Identificativo",
			placeholder_name_id: "Nome identificatore della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			secondary: "Secondari",
			decoration: "Decorazione",
			processing_time: "Tempo di preparazione",
			ingredients: "Ingredienti",
			item_shop: "Negozio",
			tapas_challenges: "Sfide culinarie",
			keyword: "Parola chiave ",
			setting: "Modello",
			error_secondary_ingredients: "Se ci sono ingredienti secondari, devi selezionare almeno un ingrediente principale e uno secondario",
			error_missing_main_ingredient: "Manca almeno un ingrediente principale nel modello",
			error_missing_secondary_ingredient: "Manca almeno un ingrediente secondario nel modello",
			error_missing_main_and_secondary: "Mancano ingredienti principali e secondari nel modello"
		},
		action: {
			name: "Nome",
			id_name: "Nome identificativo",
			placeholder_name_id: "Nome identificatore della sfida...",
			alert_name_id: "Inserisci un nome identificativo per la sfida.",
			challenges: "Sfide",
			initial_shop_challenges: "Sfide iniziali e negozio",
			categories: "Categorie",
			challenge: "Modello",
			shop: "Negozio",
			construction_challenges: "Sfide di costruzione",
			game_mode: "Modalità di gioco",
			menu_items: "Elementi di menu",
			initial_challenges: "Sfide iniziali",
			quiz: "Quiz",
			store_mode: "Costruzione",
			contest_mode: "Concorso",
			menu_points: "Punti del menu"
		},
		cluedo_ai: {
			primary_color: "Colore principale",
			secondary_color: "Colore secondario",
			timer_color: "Colore cronometro",
			points_icon: "Icona dei punti",
			name: "Nome",
			placeholder_name: "Nome della sfida...",
			id_name: "Nome identificativo",
			image: "Immagine",
			description: "Descrizione",
			placeholder_description: "Descrizione della sfida...",
			acts: "Casi (L'ordine in cui vengono aggiunti sarà quello in cui appariranno)",
			settings: "Impostazioni",
			setting: "Impostazioni"
		}
	},
	erp_settings: {
		exclude_web: "Escludi dal web",
		category: "Categorie",
		main_category: "Categoria principale",
		sub_category: "Categoria secondaria",
		create_sub_category: "Nuova categoria",
		event_service: "Servizi per eventi",
		fixed: "Fisso",
		add_price: "Aggiungi prezzo",
		location: "Posizione",
		link_location: "Link della posizione",
		placeholder_location: "Posizione del servizio eventi",
		placeholder_link_location: "Link della posizione del servizio eventi",
		event_service_name: "Nome del servizio eventi",
		placeholder_event_service_name: "Nome del servizio eventi",
		new_event_service: "Nuovo servizio eventi",
		link_app: "Link app",
		youtube_url: "URL di YouTube",
		placeholder_youtube_url: "URL del video di YouTube",
		organization: "Organizzazione",
		name: "Nome",
		placeholder_name: "Nome",
		alert_name: "Deve avere un nome",
		logo: "Logo",
		default_image: "Immagine predefinita",
		color_primary_document: "Colore principale dei documenti",
		color_secondary_document: "Colore secondario dei documenti",
		billing: "Fatturazione",
		placeholder_billing: "Dati di fatturazione...",
		billing_mail: "Email di fatturazione",
		placeholder_billing_mail: "email@azienda.com",
		holded_contact_id: "ID contatto Holded",
		placeholder_holded_contact_id: "ID del contatto in Holded",
		vat_type: "Tipo di IVA",
		vat_type_21: "21%",
		vat_type_exempt: "Esente",
		gm_info_text: "Avviso per monitori / istruttori",
		placeholder_gm_info_text: "Testo che vedranno i monitor all'apertura di una prenotazione...",
		list_activities: "Elenco Attività",
		new_activity: "Nuova Attività",
		search: "Cerca",
		placeholder_search: "Cerca per nome",
		in_person: "di persona",
		online: "Online",
		modality: "Modalità",
		alert_modality: "Seleziona una modalità",
		general_media: "Media",
		pricing_list: "Lista dei prezzi",
		activity_name: "Nome",
		placeholder_activity_name: "Nome dell'attività (Cliente)",
		duration: "Durata",
		placeholder_duration: "Durata dell'attività",
		description: "Descrizione",
		placeholder_description: "Descrizione dell'attività",
		requirements: "Requisiti",
		placeholder_requirements: "Requisiti dell'attività",
		includes: "Include",
		placeholder_includes: "Cosa include l'attività",
		dynamic: "Dinamica",
		placeholder_dynamic: "Dinamica dell'attività",
		budget_description: "Descrizione del budget",
		placeholder_budget_description: "Descrizione del budget",
		media: "Media in questa lingua",
		extras: "Extra",
		price: "Prezzo",
		activity: "Attività",
		type_price: "Tipo di prezzo",
		alert_type_price: "Seleziona un tipo di prezzo",
		new_extra: "Nuovo Extra",
		preview_pdf: "Anteprima PDF",
		staff_document: "Documento per il personale",
		extra_deleted: "L'extra è stato eliminato",
		extra_not_deleted: "L'extra non è stato eliminato",
		placeholder_name_extra: "Nome dell'extra",
		placeholder_description_extra: "Descrizione dell'extra",
		extra: "Extra",
		total: "Totale",
		by_person: "Per persona",
		final_page_budget: "Pagina finale di budget",
		new_final_page_budget: "Nuova pagina finale di budget",
		final_page_budget_deleted: "La pagina finale di budget è stata eliminata",
		final_page_budget_not_deleted: "Non è stato possibile eliminare la pagina finale di budget",
		placeholder_description_activity: "Descrizione dell'attività",
		question: "Domanda",
		placeholder_question: "Domanda",
		all_activities: "Tutte le attività",
		no_activity: "Senza attività",
		placeholder_activity: "Filtra per attività",
		questions_activities: "Domande sulle attività",
		code: "Codice",
		placeholder_code: "Codice dell'attività",
		question_booking: "Domande sulle prenotazioni",
		new_question_booking: "Nuova domanda sulle prenotazioni"
	},
	previews: {
		menu: "Menu"
	},
	login: {
		description: "Applicazione di {company} per la realizzazione di eventi di Team Building",
		email: "Email",
		placeholder_email: "Inserisci la tua email",
		password: "Password",
		placeholder_password: "Almeno 8 caratteri",
		sign_in: "Accedi",
		invalid_credentials: "Credenziali errate",
		forgor_password: "Password dimenticata"
	},
	formGenerator: {
		pricing: {
			new_price: "+ Nuovo prezzo",
			min_persons: "Persone minime",
			max_persons: "Persone massime",
			total_price: "Prezzo totale",
			person_price: "Prezzo per persona",
			price: "Prezzo"
		}
	},
	dialogs: {
		close: "Chiudi",
		sure: "Sei sicuro?",
		erase: "Elimina",
		erase_record: "Elimina registrazione",
		delete_team: "Elimina squadra",
		confirm_delete_team: "Sei sicuro di voler eliminare la squadra?",
		delete: "Elimina",
		delete_colon: "Elimina: ",
		cancel: "Annulla",
		name: "Nome",
		add: "Aggiungi",
		placeholder_team: "Squadra..",
		edit_team: "Modifica squadra",
		save: "Salva",
		demo_limit: "Le attività demo consentono solo 2 squadre",
		link_staff: "Collegamento Staff",
		link_admin: "Collegamento Amministratore",
		link_results: "Collegamento Risultati",
		go_results: "Vai ai risultati",
		add_team: "Aggiungi squadra",
		material_recalculate: "Creando la squadra verrà ricalcolato il materiale",
		material_tab_no_update_add_teams: "La scheda materiale non si aggiornerà se aggiungi squadre",
		warning: "Avviso",
		add_team_money: "Aggiungi soldi squadra",
		link_teams: "Collegamento Squadre",
		challenge_delete: "Si eliminerà la sfida: ",
		create: "Crea",
		challenge: "Sfida",
		item: "Articolo",
		stock: "Stock",
		placeholder_challenge: "Seleziona una sfida",
		warning_change_template: "Cambiando il modello verranno cancellate tutte le sfide",
		team: "Squadra",
		teams: "Squadre",
		points_negative: "Punti (possono essere negativi)",
		money_negative: "Denaro (può essere negativo)",
		minutes: "Minuti",
		seconds: "Secondi",
		substract: "Sottrarre",
		expected_answer: "Risposta attesa: ",
		challenge_score: "Punteggio sfida",
		activate: "Attivare",
		material_recalculate_delete: "Eliminando l'attrezzatura si ricalcolerà il materiale",
		add_route: "Aggiungi percorso",
		confirm: "Confermare",
		accept: "Accettare",
		activity: "Attività",
		language: "Lingua",
		placeholder_language: "Seleziona una lingua",
		logo: "Logo",
		sure_delete_acitivty: "Sei sicuro di voler eliminare l'attività?",
		add_favorite: "Aggiungi ai preferiti",
		delete_favorite: "Rimuovi dai preferiti",
		date: "Data",
		unsaved_changes_content: "Sei sicuro?",
		unsaved_changes_title: "Si perderanno le modifiche non salvate",
		stay: "Rimanere",
		exit: "Uscire",
		client_validate: "È necessaria la convalida dei dati del cliente",
		close_booking: "Chiudere la prenotazione",
		cancel_reason: "Motivo della cancellazione",
		finish: "Completare",
		favorite_challenge: "Preferito",
		object: "Oggetto",
		character: "Personaggio",
		key_information: "Informazioni chiave",
		give: "Dare",
		key_information_done: "Informazioni chiave completate",
		give_key_information: "Dare informazioni chiave",
		team_components_precreated_only: "I membri del team possono essere utilizzati solo in partite online, dove gli utenti selezionano il proprio team dalla pagina delle squadre.",
		team_components: "Componenti del team",
		team_components_placeholder: "Aggiungi un componente e premi invio"
	},
	camera: {
		title_error_modal: "Errore nella fotocamera",
		text_error_modal: "Avvisare la persona dello staff per controllare la fotocamera. Errore: ",
		btn_reload_app: "Ricarica l'app",
		btn_load_foto: "Carica foto dalla galleria",
		modal_upload_title: "Carica Foto",
		modal_upload_text: "Puoi caricare la tua foto dalla galleria",
		error_no_upload: "Devi caricare una foto prima",
		error_upload_photo: "Errore nel caricamento della foto, riprova"
	},
	chat: {
		message: "Messaggio",
		message_placeholder: "Scrivi il tuo messaggio",
		message_btn: "Invia messaggio",
		send: "Inviato",
		read: "Letto",
		new_message_summary: "Nuovo messaggio di chat",
		new_message_detail: "Hai un nuovo messaggio dal STAFF"
	},
	customization: {
		common_sense: {
			subtitle: "Personalizza la tua esperienza Common Sense",
			not_found: "Questo link di personalizzazione non è valido.",
			tab_personalization: "Personalizzazione",
			tab_create_content: "Crea contenuto",
			challenges_selection: "Selezione di sfide",
			challenges_selection_hint: "Attiva le sfide che desideri utilizzare. Puoi espandere ciascuna per visualizzare domande e risposte (solo lettura).",
			challenges_view: "Sfide",
			challenges_view_hint: "Vista di sola lettura. Espandi ogni sfida per vedere domande e risposte.",
			read_only_notice: "Questo collegamento è di sola lettura. Puoi rivedere il contenuto ma non modificare, attivare né aggiungere sfide.",
			no_challenges: "Non ci sono sfide configurate in questo modello.",
			upload_image: "Carica immagine",
			event_logo: "Logo dell'evento",
			event_logo_hint: "Questo logo verrà utilizzato nella schermata pubblica del gioco quando verrà selezionato questo modello.",
			logo_saved: "Logo salvato",
			logo_save_error: "Impossibile salvare il logo",
			public_link: "Collegamento di personalizzazione cliente",
			public_link_hint: "Condividi questo collegamento con il tuo cliente. Viene generato al salvataggio del modello.",
			challenges_client: "Sfide selezionate dal cliente",
			no_questions: "Non ci sono domande configurate.",
			untitled_question: "Domanda senza titolo",
			untitled_step: "Passo senza titolo",
			correct: "corretta",
			correct_answer: "Risposta corretta",
			select_challenge: "Seleziona una sfida",
			new_challenge: "Nuova sfida",
			add_challenge: "Aggiungi sfida",
			challenge_added: "Sfida aggiunta",
			challenge_name_required: "Indica un nome per la sfida",
			delete_challenge: "Elimina",
			delete_challenge_confirm_title: "Eliminare questa sfida?",
			delete_challenge_confirm_message: "Sarà eliminato «{name}» da questo modello. Questa azione non può essere annullata.",
			challenge_deleted: "Sfida eliminata",
			nothing_enabled: "Non ci sono opzioni di personalizzazione abilitate per questo modello.",
			client_edit: "Il cliente può modificare questa sfida",
			autosave_saving: "Salvataggio…",
			autosave_saved: "Modifiche salvate",
			autosave_error: "Impossibile salvare. Riprova.",
			challenges_client_hint: "Puoi scegliere solo sfide che sono già selezionate in «Sfide».",
			challenges_client_select_master_first: "Seleziona almeno una sfida in «Sfide» per poter configurare le sfide del cliente."
		}
	},
	gm: {
		modals: {
			add_monitor: "Aggiungi monitor",
			save: "Salva",
			name: "Nome",
			placeholder_name: "Nome Monitor",
			saved_monitor: "Monitor salvato",
			continue: "Continua",
			change: "Cambia",
			exit: "Esci",
			cancel: "Annulla",
			exit_event: "Esci dall'evento",
			password: "Password",
			enter_name: "Inserisci il tuo nome"
		},
		ranking: {
			show: "Mostra Ranking",
			hide: "Nascondi Ranking"
		},
		dashboards: {
			teams: "Squadre",
			credits_to_consume: "Crediti da consumare",
			unit_cost: "Costo unitario",
			links: "Collegamenti",
			name: "Nome della squadra",
			chat: "Chat",
			configuration: "Configurazione generale",
			configuration_activity: "Configurazione attività",
			link_ranking: "Collegamento Ranking",
			link_results: "Collegamento Risultati",
			link_monitors: "Collegamento Monitor",
			link_admin: "Collegamento Admin",
			link_presentation: "Collegamento Presentazione",
			link_teams: "Collegamento Squadre",
			list_ingredients: "Lista ingredienti",
			link_favorite_images: "Collegamento immagini preferite",
			total: "Totale",
			remaining: "Restante",
			round_ends: "Fine del turno",
			round: "Turno",
			play: "Gioca",
			resume: "Riprendi",
			pause: "Pausa",
			pass_round: "Salta turno",
			time_ranking: "Vedi tempo in classifica",
			results: "Risultati",
			add_team: "Aggiungi squadra",
			add_teams: "Aggiungi squadre",
			order_points: "Ordina classifica per punti",
			add_challenges_first: "Aggiungi prima le sfide",
			general: "Generale",
			material: "Materiale",
			event_configuration: "Configura prima l'evento",
			back: "Indietro",
			save: "Salva",
			challenges: "Sfide",
			score_categories: "Categorie di punteggio",
			defense: "DIFESA",
			presentation: "PRESENTAZIONE",
			flavor: "SFOGLIA",
			money: "DENARO",
			round_time: "Tempo per round",
			tapas_time: "Tempo di cucina",
			round_time_minutes: "Tempo per round (minuti)",
			type: "Modello",
			placeholder_type: "Seleziona un tipo",
			setting_logo_replace_title: "Usare il logo del modello?",
			setting_logo_replace_message: "L'evento ha già un logo. Vuoi mantenere quello attuale o usare il logo configurato dal cliente nel modello?",
			setting_logo_keep_event: "Mantieni logo dell'evento",
			setting_logo_use_setting: "Usa logo del modello",
			ingredient: "Ingredienti",
			shop: "Negozio",
			select_challenge: "Seleziona un reto",
			select_activity: "Seleziona un'attività",
			select_time_round: "Imposta un tempo per turno",
			select_time_tapas: "Imposta un tempo per realizzare le tapas",
			select_categories: "Per favore seleziona le categorie",
			team_turn: "Turno della squadra",
			type_election: "Tipo di elezione",
			round_election: "Ronda di elezione",
			round_total: "Ronda totale",
			time_elaboration: "Tempo di elaborazione",
			name_team: "Dai un nome alla squadra",
			number_teams: "Numero di squadre",
			total_ingredients: "Totale ingredienti",
			extra_ingredients: "Ingredienti extra",
			total_decoration: "Totale decorazione",
			extra_decoration: "Decorazione extra",
			missing_ingredients: "Ingredienti mancanti",
			list_download: "Scarica lista",
			ingredients: "Ingredienti",
			saved: "Salvato",
			start_game: "Inizia gioco",
			gm: "Monitor",
			monitors: "Monitor",
			monitors_visible: "Monitor visibili",
			monitors_hidden: "Monitor nascosti",
			readed: "Letto",
			sent: "Inviato",
			message_team: "Scrivi un messaggio al team",
			message_all_teams: "I messaggi che scrivi verranno inviati a tutti i team",
			your_message: "Il tuo messaggio",
			upload_image: "Carica immagine",
			add_emoji: "Aggiungi emoticon",
			send_message: "Invia messaggio",
			all: "Tutti",
			challenge: "Sfida",
			id_name: "Nome identificativo",
			latitude: "Latitudine",
			longitude: "Longitudine",
			activations_radius: "Raggio di attivazione",
			categories_points: "Categorie di punteggio",
			must_upper: "OBBLIGATORIA",
			first_upper: "PRIMO",
			type_activation: "Tipo di attivazione",
			qr_upper: "QR",
			qr_code: "Codice QR",
			location_upper: "POSIZIONE",
			first: "Prima",
			must: "Obbligatoria",
			add_challenges: "Aggiungi sfide",
			select_latitude: "Seleziona una latitudine",
			select_longitude: "Seleziona una longitudine",
			placeholder_id_name: "Inserisci un nome identificativo",
			placeholder_template: "Seleziona un modello",
			put_duration: "Inserisci una durata",
			initial_position: "Posizione iniziale",
			not_template: "Senza modello",
			template: "Modello",
			placeholder_search_address: "Cerca un indirizzo...",
			drag_drop_image: "Trascina e rilascia un'immagine qui",
			or_click_upload: "o fai clic per caricare",
			no_image: "Nessuna immagine disponibile",
			duration_seconds: "Durata (minuti)",
			duration_hours: "Durata Ore",
			duration_minutes: "Durata Minuti",
			categories: "Categorie",
			time_action: "Imposta un tempo per completare le sfide",
			routes: "Percorsi",
			team_no_route: "Ci sono team senza percorso",
			changes_not_saved: "Modifiche non salvate",
			route: "Percorso",
			order: "Ordine: ",
			name_route: "Nome",
			placeholder_name_route: "Nome della route",
			event: "Evento",
			select_setting: "Seleziona una configurazione",
			initial_challenges: "Sfide Iniziali",
			time_higher_zero: "Il tempo deve essere maggiore di 0",
			time_required: "Il tempo per round è richiesto",
			time_integer: "Il tempo deve essere un intero",
			warning_template: "Se non scegli un template dovrai creare manualmente tutte le sfide.",
			add_teams_first: "Prima di aggiungere materiale devi aggiungere squadre",
			acts: "Casi",
			placeholder_acts: "Seleziona un caso",
			qr_codes: "Codici QR",
			objects: "Oggetti",
			characters: "Personaggi",
			type_game: "Tipo di gioco",
			team_mode: "Configurazione di squadre",
			alert_team_mode: "Seleziona una configurazione di squadre",
			team_mode_on_the_fly: "Squadre al volo",
			team_mode_on_the_fly_desc: "I giocatori entrano prima nella lobby e le squadre vengono create successivamente. Questa modalità può funzionare con posizioni (per raggruppare o identificare i giocatori per tavolo, sala, città, sede, ecc.) o senza posizioni (tutti i giocatori entrano e poi si creano le squadre).",
			team_mode_precreated: "Squadre precreate",
			team_mode_precreated_desc: "Utilizza il sistema attuale di Teaming App, dove le squadre sono già create in precedenza prima di avviare la partita.",
			map_configuration: "Configurazione della mappa",
			finish_latitude: "Latitudine finale",
			finish_longitude: "Longitudine finale",
			map: "Mappa",
			init: "Inizio",
			finish: "Fine",
			online: "Online",
			presential: "Presenziale",
			hybrid: "Ibrido",
			game_image: "Carica l'immagine che vedranno i giocatori nella loro app",
			sets: "Set"
		},
		utq: {
			change_monitor: "Cambia Monitor",
			round: "Round",
			ends: "Finisce",
			start: "Inizia",
			team_upper: "SQUADRA",
			position_upper: "POSIZIONE",
			points_upper: "PUNTI",
			team: "Squadra",
			placeholder_team: "Seleziona una squadra",
			score: "Punteggio",
			rate: "Valuta",
			instructions_material: "Istruzioni e materiale",
			name_event: "Assegna un nome all'evento",
			select_team: "Seleziona una squadra",
			operation: "Funzionamento",
			material: "Materiale"
		},
		tapas: {
			disponible_later: "Disponibile più tardi",
			round_ends: "Ronda conclusa",
			score_missing: "Ci sono sfide non punteggiate per le squadre",
			start_challenges: "Iniziare le sfide",
			start_selection: "Iniziare la selezione degli ingredienti",
			start_elaboration: "Iniziare il tempo di elaborazione",
			pass_round: "Saltare la ronda",
			selecting_ingredients: "Selezionando ingredienti",
			pass_selection: "Saltare la selezione",
			team_turn: "Turno della squadra",
			type_selection: "Tipo di selezione",
			round_selection: "Turno di selezione",
			round_total: "Totale del turno",
			votes: "Votazioni",
			type_choice: "Tipo di scelta",
			top_1: "Top 1",
			top_2: "Top 2",
			top_3: "Top 3",
			round: "Turno",
			time_eleboration: "Tempo di elaborazione",
			start: "Iniziare",
			challenges: "Sfide",
			placeholder_challenge: "Seleziona una sfida e premi inizia",
			orders: "Ordini",
			change_money: "Modifica denaro",
			shop: "Negozio",
			challenges_results: "Risultati delle sfide",
			ingredient_selection: "Selezione degli ingredienti",
			winners: "Vincitori",
			placeholder_select_team: "Seleziona una squadra",
			category: "Categoria",
			rate: "Valuta",
			defense: "Difesa",
			show: "Presentazione",
			flavour: "Gusto",
			change_main_ingredient: "Cambia Ingrediente Principale",
			challenges_done: "Sfide completate"
		},
		ipad: {
			time_game: "Tempo di gioco",
			start_game: "Inizia Gioco",
			add_delete_time: "Aggiungi/Rimuovi Tempo",
			hide_ranking: "Nascondi Ranking",
			show_ranking: "Mostra Ranking",
			lock_challenges: "Blocca Sfide",
			unlock_challenges: "Sblocca Sfide",
			move_challenges: "Sposta prove",
			challenges: "Sfide",
			clean_filters: "Pulisci filtri",
			add_delete_points: "Aggiungi/Rimuovi Punti",
			activate_challenge: "Attiva sfida",
			no_route: "Nessun Percorso",
			instructor: "Istruttore",
			player: "Giocatore",
			team: "Squadra",
			points: "Punti",
			challenges_done: "Sfide Completate",
			last_challenge: "Ultima Sfida",
			hour: "Ora",
			must: "Obbligatori",
			optionals: "Facoltativi",
			status_not_started: "Non iniziato",
			status_started: "Iniziato",
			status_pending: "In cammino",
			status_done: "Completato",
			select_team_to_view_challenges: "Seleziona una squadra per vedere le sfide"
		},
		action: {
			next_challenge: "Forza sfida",
			start: "Iniziare",
			next: "Successivo",
			time_game: "Tempo di gioco",
			start_game: "Inizia gioco",
			add_delete_time: "Aggiungi/Rimuovi tempo",
			ranking: "Classifica",
			finish_game: "Finalizza Gioco",
			reactivate_game: "Riattiva Gioco",
			challenges: "Sfide",
			clean_filters: "Pulisci filtri",
			team_filter: "Filtro Squadra",
			challenge_filter: "Filtro Sfida",
			add_delete_points: "Aggiungi/Rimuovi Punti",
			add_delete_money: "Aggiungi/Rimuovi Denaro",
			activate_quiz: "Attiva Quiz",
			ranking_normal: "Normale",
			ranking_coop: "Cooperativo",
			ranking_both: "Entrambi",
			ranking_hidden: "Nascosto",
			ranking_slides: "Diapositive",
			activate_challenge: "Attiva sfida",
			show_videos: "Immagini Finali",
			select_action: "Stato",
			quizzes: "Questionari",
			challenge_not_start: "Non è ancora iniziata nessuna sfida",
			challenges_pick: "Sfide da raccogliere",
			challenges_return: "Sfide da restituire",
			challenges_material: "Materiale sfide",
			update_stock: "Modificare Stock",
			update_initial_stock: "Modificare stock iniziale",
			picked_challenges: "Sfide Raccoglibili",
			fake_upload: "Caricamento Falso",
			no_picked_challenges: "Non ci sono sfide raccolte disponibili",
			stock_upper: "STOCK: ",
			stock_initial_upper: "STOCK INIZIALE: ",
			stock: "Stock",
			team_upper: "TEAM",
			challenge_upper: "SFIDA",
			returned_upper: "RESO",
			delivered_upper: "CONSEGNATO",
			team: "Squadra",
			points: "Punti",
			money: "Denaro",
			quizzes_done: "Questionari Completati",
			challenges_done: "Sfide Completate",
			last_challenge: "Ultima Sfida",
			material: "Materiale",
			save: "Salva",
			material_to_pick: "Materiale da Ritirare",
			stock_shop: "Stock Negozio",
			delivery: "Consegna",
			challenge_started: "Reto iniziato",
			error_start_challenge: "Errore nell'avviare il reto",
			challenge_flash: "Reto Flash",
			add_favorite: "Aggiungi ai preferiti",
			delete_favorite: "Rimuovi dai preferiti"
		},
		cluedo_ai: {
			pause_game: "Pausa Gioco",
			resume_game: "Riprendi Gioco",
			no_chat: "Nessuna chat",
			game_done: "Gioco terminato. Vai al punto di incontro finale.",
			act_information: "Informazioni del caso",
			characters: "Personaggi",
			objects: "Oggetti",
			key_informations: "Informazioni chiave",
			chat: "Chat",
			ranking: "Classifica",
			configuration: "Configurazione",
			start_game: "Inizia Gioco",
			next_act: "Prossimo Caso",
			add_points: "Aggiungi Punti",
			add_time: "Aggiungi Tempo",
			give_object: "Dai Oggetto",
			give_information: "Dai Informazioni",
			questions: "Domande",
			team: "Squadra",
			points: "Punti",
			objects_found: "Oggetti trovati",
			characters_found: "Personaggi trovati",
			questions_answered: "Domande risposte",
			position: "Posizione",
			add_delete_time: "Aggiungi/Rimuovi Tempo",
			add_delete_points: "Aggiungi/Rimuovi Punti",
			participants_answer: "Risposta partecipanti",
			correct_answer: "Risposta corretta",
			score: "Punteggio",
			feedback: "Feedback",
			not_evaluated: "Non valutato",
			edit_question: "Modifica domanda",
			last_act: "Ultimo caso",
			evaluated: "Valutato",
			confirm_start_game: "Sei sicuro di voler iniziare il gioco?",
			confirm_next_act: "Sei sicuro di voler passare al caso successivo?",
			confirm_last_act: "Sei sicuro di voler terminare l'ultimo caso?",
		},
		collabo: {
			player_answer: "Risposta del giocatore",
			double_materials_mode: "Modalità Materiali Duplicati",
			material_multiplier_title: "Moltiplicatore di materiali",
			material_multiplier_configure: "Configura moltiplicatore",
			material_multiplier_next_distribution: "Verrà applicato alla prossima distribuzione di materiali.",
			material_multiplier_updated: "Moltiplicatore di materiali aggiornato correttamente",
			material_multiplier_x1_hint: "Ideale per più di 30 pax",
			material_multiplier_x2_hint: "Ideale per 20 a 30 pax",
			material_multiplier_x3_hint: "Ideale da 10 a 20 pax",
			material_multiplier_x4_hint: "Meno di 10 pax",
			double_materials_mode_on: "Attivato",
			double_materials_mode_off: "Disattivato",
			stage_give_material: "Dare Materiale",
			select_team: "Selezionare Squadra",
			select_material: "Selezionare Materiale",
			enter_quantity: "Inserire Quantità",
			quantity_by_team: "Quantità per squadra",
			enter_quantity_by_team: "Inserire quantità per squadra",
			give_material: "Dare Materiale",
			material_given_success: "Materiale dato correttamente",
			material_given_error: "Errore nel dare il materiale",
			material: "Material",
			double_materials_mode_updated: "Modalità Materiali Duplicati aggiornata correttamente",
			quantity: "Quantità",
			controls: "Controlli",
			total_teams: "Totale Squadre",
			total_rounds: "Totale di turni",
			start_final_construction_round: "Inizia il turno finale di costruzione",
			final_construction_round_started: "Turno finale di costruzione iniziato",
			undo_final_construction_round: "Annulla il turno finale di costruzione",
			confirm_start_final_construction_round: "Sei sicuro di voler passare alla modalità finale di costruzione?",
			confirm_undo_final_construction_round: "Sei sicuro di voler annullare la modalità finale di costruzione?",
			final_construction_round_undone: "Turno finale di costruzione annullato",
			teams_list: "Elenco delle Squadre",
			start_game: "Inizia Gioco",
			no_teams: "Non ci sono squadre",
			game_started: "Gioco iniziato correttamente",
			game_start_error: "Errore nell'avvio del gioco",
			challenges_status: "Stato delle Sfide",
			confirmed_teams: "Squadre Confermate",
			total_points: "Punti Totali",
			correct_answer: "Risposta Corretta",
			solution: "Soluzione",
			players_response: "Risposta delle squadre",
			team_removed_from_challenge: "Squadra rimossa dalla sfida",
			team_remove_from_challenge_error: "Errore nella rimozione della squadra dalla sfida",
			construction_phase_started: "Fase di costruzione iniziata",
			construction_phase_error: "Errore nell'avvio della fase di costruzione",
			construction_phase: "Fase di Costruzione",
			constructions_in_progress: "Costruzioni In Corso",
			no_constructions_in_progress: "Non ci sono costruzioni in corso",
			building_type: "Tipo di Costruzione",
			leading_team: "Squadra Leader",
			helping_teams: "Squadre di Supporto",
			completed_constructions: "Costruzioni Completate",
			no_completed_constructions: "Non ci sono costruzioni completate",
			view_all_constructions: "Visualizza tutte",
			all_completed_constructions: "Tutte le costruzioni completate",
			all_constructions_ordered_by_last_done: "Elenco ordinato per la costruzione più recente per prima.",
			constructions_of_type_ordered_by_last_done: "Tutte le costruzioni di questo tipo, ordinate dalla più recente per prima.",
			order: "#",
			remaining_materials: "Materiali Rimanenti",
			construction_phase_finished: "Fase di costruzione completata",
			construction_phase_finish_error: "Errore nel completare la fase di costruzione",
			team: "Squadra",
			position: "Posizione",
			points: "Punti",
			chat: "Chat",
			ranking: "Classifica",
			configuration: "Configurazione",
			go_to_construction: "Vai alla Fase di Costruzione",
			finish_construction_phase: "Finalizza Fase di Costruzione",
			show_teams: "Mostra Squadre",
			hide_teams: "Nascondi Squadre",
			unsaved_changes: "Hai modifiche non salvate",
			save: "Salva",
			number_of_challenges: "Numero di sfide",
			link_teams: "Collega Squadre",
			link_monitors: "Collega Monitor",
			link_staff: "Collega Staff",
			add_team: "Aggiungi Squadra",
			add_teams: "Aggiungi Squadre",
			materials: "Materiali",
			no_materials: "Nessun materiale",
			constructions: "Costruzioni",
			no_constructions: "Nessuna costruzione",
			challenges: "Sfide",
			no_challenges: "Nessuna sfida",
			round_time: "Tempo di round",
			minutes: "Minuti",
			round_time_placeholder: "Inserisci il tempo di round in minuti",
			challenge_time: "Tempo di costruzione",
			challenge_time_placeholder: "Inserisci il tempo di costruzione in minuti",
			game_mode: "Modalità di gioco",
			teams: "Squadre",
			individual: "Individuale",
			ranking_title: "Titolo della classifica",
			ranking_title_placeholder: "Titolo mostrato nella schermata pubblica della classifica",
			total: "Totale"
		},
		common_sense: {
			controls: "Controlli",
			total_teams: "Totale di Squadre",
			no_teams: "Non ci sono squadre",
			start_game: "Inizia Gioco",
			pause_game: "Metti in Pausa Gioco",
			resume_game: "Riprendi Gioco",
			show_final_ranking: "Mostra classifica finale",
			game_final_ranking: "Classifica finale",
			game_status_final_ranking: "Classifica finale",
			final_ranking_shown: "Classifica finale mostrata",
			game_resumed: "Gioco ripreso",
			game_running: "Gioco in corso",
			game_paused: "Gioco in pausa",
			teams_list: "Lista delle Squadre",
			game_started: "Gioco avviato correttamente",
			game_start_error: "Errore nell'avvio del gioco",
			ranking: "Classifica",
			challenge_ranking: "Classifica della sfida",
			ranking_your_team: "La tua squadra",
			ranking_leaderboard: "Classifica",
			ranking_points_abbr: "pts",
			ranking_number_header: "N.º",
			team: "Squadra",
			position: "Posizione",
			points: "Punti",
			phase: "Fase",
			roulette: "Ruota",
			roulette_stage_title: "Sfide della roulette di squadra",
			select_challenge: "Seleziona una sfida",
			challenge_started_times: "({count}×)",
			roulette_start: "Iniziare",
			public_rules_show: "Mostra regole sulla schermata pubblica",
			public_rules_hide: "Nascondi regole sulla schermata pubblica",
			roulette_hint: "Seleziona una sfida e inizia la roulette.",
			flow_mode: "Modalità Flow",
			flow_mode_hint: "Ordina le sfide e salva affinché l'istruttore debba solo premere Avanti.",
			flow_instructor_hint: "Attiva il Flow per procedere con Avanti. Puoi modificare l'ordine e i potenziatori prima di continuare se hai bisogno di apportare modifiche last minute.",
			flow_event_hint: "Definisci l'ordine del flow per questo evento. Potrai cambiarlo in diretta se necessario.",
			flow_remove_challenge: "Rimuovi sfida dal flow",
			flow_restore_all: "Ripristina tutto",
			flow_restore_selected: "Usa sfide selezionate",
			flow_position: "Posizione",
			flow_no_booster: "Senza booster",
			flow_configure: "Configura Flow",
			flow_enabled: "Flow attivo",
			flow_disabled: "Flow inattivo",
			flow_challenge_progress: "Gioco {current} di {total}",
			skip_flow_challenge: "Salta il reto",
			skip_flow_challenge_confirm: "Sei sicuro di voler saltare questo reto? Se è in corso passerai alla schermata principale; se non è ancora iniziato verrà omesso dal flow senza mostrarsi ai giocatori.",
			skip_flow_challenge_done: "Reto saltato",
			next: "Successivo",
			advance_phase: "Avanza fase",
			finish_challenge: "Completa il reto",
			finish_ranking: "Completa il ranking",
			reset_to_waiting_challenge: "Ritorna a scegliere il reto",
			reset_to_waiting_challenge_confirm: "Tornerai alla fase di attesa (roulette) senza mostrare il ranking del reto né completare i turni in sospeso. I punti già assegnati nei turni precedenti rimangono.",
			reset_to_waiting_challenge_done: "Fase ripristinata: puoi scegliere un nuovo reto",
			add_substract_points: "Somma / sottrai punti",
			points_hint: "Usa valori negativi per sottrarre.",
			boosters: "Boosters",
			booster_half_time: "Metà tempo",
			booster_points_x2: "Punti x2",
			select_booster: "Seleziona un booster",
			apply_booster: "Applica booster",
			roulette_challenge_image_alt: "Immagine della sfida: {name}",
			roulette_challenge_default: "Sfida {id}",
			roulette_show_badge: "SFIDA",
			public_no_challenges: "Non ci sono sfide configurate per questo evento.",
			public_loading: "Caricamento…",
			public_waiting_game: "In attesa che l'host avvii il gioco.",
			public_waiting_challenge: "Quando l'host presenterà una sfida, la roulette verrà riprodotta qui.",
			player_menu_play: "Gioco",
			player_menu_settings: "Impostazioni",
			instructor_menu_controls: "Controlli del gioco",
			instructor_menu_ranking: "Classifica",
			instructor_menu_settings: "Configurazione",
			ranking_team_fallback: "Squadra {id}",
			public_challenge_rules: "Regole del challenge",
			public_no_rules_text: "Non ci sono testo di regole configurato per questo challenge.",
			challenge_play_subphase: "Fase del challenge {n}",
			in_challenge_phase_waiting: "In attesa del challenge",
			in_challenge_phase_rolling: "Ruota",
			in_challenge_phase_showing_rules: "Mostrando regole",
			in_challenge_phase_playing: "Challenge in gioco",
			in_challenge_phase_result: "Risultato del challenge",
			in_challenge_phase_ranking: "Classifica",
			in_challenge_phase_unknown: "Fase sconosciuta",
			challenge_subphase_progress: "{current} di {total}",
			challenge_subphase_of: "di",
			phase_code: "Fase {code}",
			challenge_no_active: "Non ci sono sfide attive selezionate.",
			challenge_fair_prize_play: "Sfida sul prezzo equo — schermo di gioco",
			challenge_quiz_play: "Sfida tipo quiz — schermo di gioco",
			challenge_timeline_play: "Sfida sulla linea temporale — schermo di gioco",
			timeline_no_rounds: "Non ci sono round della linea temporale configurati per questa sfida.",
			timeline_question_heading: "Ordina i passaggi",
			timeline_order_hint: "Ordina le carte. Puoi cambiare l'ordine fino a quando il tempo non scade.",
			timeline_order_context_aria: "Come ordinare la linea temporale",
			timeline_position: "{n}",
			timeline_question_label: "Domanda {n}",
			timeline_timer_aria: "Tempo rimasto",
			phase_timer_question: "Tempo",
			phase_timer_results: "Tempo",
			timeline_steps_aria: "Passi da ordinare",
			timeline_submit_answer: "Invia ordine",
			timeline_answer_submitted: "Ordine inviato",
			timeline_result_intro: "Il tuo ordine e i punti di ciascuna carta.",
			timeline_result_round_label: "Punti di questo turno",
			timeline_result_no_movement: "Non hai effettuato alcun movimento.",
			timeline_result_total: "+{n} pts",
			timeline_result_points: "+{n}",
			timeline_result_correct: "Corretto",
			timeline_result_semi: "Quasi",
			timeline_result_wrong: "Errato",
			timeline_result_should_be: "Ordine corretto: {n}",
			timeline_public_result_hint: "Ordine corretto della sequenza.",
			timeline_public_team_hits: "Colpi di squadra: {n}",
			timeline_public_perfect_order: "Ordine perfetto",
			timeline_public_perfect_score: "({correct}/{total})",
			quiz_no_questions: "Non ci sono domande di quiz configurate per questa sfida.",
			quiz_question_heading: "Domanda",
			quiz_answers_aria: "Opzioni di risposta",
			quiz_select_answer: "Scegli la tua risposta",
			quiz_submit_answer: "Invia risposta",
			quiz_answer_submitted: "Risposta inviata",
			quiz_change_until_time_end: "Puoi cambiare la tua risposta fino alla fine del tempo.",
			quiz_result_teams_pct: "{count}/{total} · {pct}%",
			quiz_waiting_play: "Aspetta che l'istruttore avvii il turno della sfida.",
			fair_prize_question_heading: "Domanda",
			fair_prize_slider_aria: "Slider dell'intervallo di prezzo",
			fair_prize_range_from: "Da",
			fair_prize_range_to: "A",
			fair_prize_your_guess: "La tua stima",
			fair_prize_select_value: "Trascina il cursore per indicare la tua migliore risposta",
			fair_prize_submit_answer: "Invia risposta",
			fair_prize_answer_submitted: "Risposta inviata",
			fair_prize_change_until_time_end: "Puoi cambiare la tua stima fino alla scadenza",
			fair_prize_no_questions: "Non ci sono tornate di prezzo equo impostate per questa sfida.",
			fair_prize_correct_answer: "Risposta corretta",
			fair_prize_result_your_guess: "La tua stima",
			fair_prize_result_no_adjustment: "Non hai modificato la tua stima.",
			fair_prize_legend_correct: "Corretta",
			fair_prize_legend_your_team: "Il tuo team",
			fair_prize_legend_others: "Altri",
			fair_prize_all_team_answers: "Risposte di tutti i team",
			fair_prize_no_team_answers: "Non ci sono ancora risposte dai team",
			fair_prize_teams_count: "{n} team",
			fair_prize_teams_label: "squadre",
			quiz_correct_answer: "Risposta corretta",
			challenge_result_badge: "Risultato",
			rules_fair_prize_badge: "Sfida del premio equo",
			rules_timeline_badge: "Sfida della linea temporale",
			rules_quiz_badge: "Sfida tipo quiz",
			rules_section_kicker: "Sfida",
			rules_quiz_type: "Scelte multiple",
			rules_timeline_type: "Ordinare",
			rules_fair_prize_type: "Stima",
			rules_quiz_intro: "{count} domande. Rispondi prima che scada il tempo: più rispondi veloce, più punti guadagna la tua squadra.",
			rules_timeline_intro: "{count} round di ordinamento. Posiziona i passaggi nell'ordine corretto prima che scada il tempo.",
			rules_fair_prize_intro: "{count} round di stima. Indovina il valore più vicino prima che scada il tempo.",
			rules_quiz_demo_title: "Tocca una risposta",
			rules_quiz_demo_hint: "Clicca sulla scheda colorata che pensi sia corretta. Puoi cambiare la tua risposta fino alla scadenza del tempo.",
			rules_timeline_demo_title: "Trascina per ordinare",
			rules_timeline_demo_hint: "Tieni premuta ogni scheda e trascinala su o giù fino a ottenere la sequenza corretta. Puoi cambiare l'ordine fino alla fine del tempo.",
			rules_timeline_step_a: "Passo A",
			rules_timeline_step_b: "Passo B",
			rules_timeline_step_c: "Passo C",
			rules_fair_prize_demo_title: "Regola il numero",
			rules_fair_prize_demo_hint: "Scorri il cursore o usa i pulsanti − e + per affinare la tua stima. Vince chi si avvicina di più.",
			player_challenges_heading: "I tuoi sfide",
			player_challenges_subtitle: "Scegli una sfida quando l'host la attiva nella roulette per giocare.",
			player_challenge_active_now: "Attivo ora",
			player_challenge_not_active: "Questa sfida non è ancora attiva. Aspetta che l'host la tiri fuori nella roulette.",
			player_challenge_open_play: "Gioca ora",
			player_challenge_view_details: "Vedi dettagli",
			player_back_to_challenges: "Tutte le sfide"
		}
	},
	errors: {
		required: "Questo campo è obbligatorio",
		invalid_email: "L'email non è valido",
		invalid_url: "L'URL non è valida",
		invalid_number: "Il numero non è valido",
		field_invalid: "Campo {field} non valido",
		connection: "Errore di connessione con il server",
		unauthorized: "Non hai il permesso di eseguire questa azione",
		not_found: "Il record non è stato trovato",
		conflict: "Esiste già un record con questi dati",
		server: "Si è verificato un errore nel server"
	},
	messages: {
		error_generating_pdf: "Non è stato possibile generare il PDF",
		join_game_success: "Sei entrato nel gioco correttamente",
		success: "Successo",
		download_completed: "Download completato",
		error: "Errore",
		error_downloading: "Non è stato possibile scaricare il file",
		game_paused: "Gioco in pausa",
		game_resumed: "Gioco ripreso",
		round_pass: "Turno saltato",
		canceled: "Annullato",
		deleted: "Eliminato",
		updated: "Aggiornato",
		added: "Aggiunto",
		monitor_added: "Monitor aggiunto correttamente",
		monitor_updated: "Monitor aggiornato correttamente",
		monitor_not_added: "Non è stato possibile aggiungere il monitor",
		score_ok: "Punteggio inviato correttamente",
		score_not_ok: "Non è stato possibile inviare il punteggio",
		score_add: "Imposta un punteggio",
		select_team: "Seleziona una squadra",
		team_error: "Non è stato possibile aggiungere la squadra",
		team_correctly: "Squadra {msg} correttamente",
		incorrect_fields: "Ci sono campi errati nel modulo",
		tapas_succesfull_updated: "Attività Guerra di Tapas aggiornata correttamente",
		tapas_not_succesfull_updated: "Non è stato possibile aggiornare l'attività Guerra di Tapas",
		tapas_succesfull_added: "Attività Guerra di Tapas aggiunta correttamente",
		tapas_not_succesfull_added: "Non è stato possibile aggiungere l'attività Guerra di Tapas",
		select_passed: "Selezione saltata",
		link_copied: "Collegamento copiato",
		votes_deleted: "Voti eliminati correttamente",
		votes_not_deleted: "Non è stato possibile eliminare i voti",
		money_updated: "Denaro aggiornato",
		teams_added: "Squadre aggiunte correttamente",
		game_started: "Gioco Iniziato",
		deleted_ok: "Eliminato correttamente",
		deleted_not_ok: "Non è stato possibile eliminare",
		updated_not_ok: "Non è stato possibile aggiornare",
		select_challenge: "Seleziona una sfida",
		challenges: "Sfide",
		template: "Modello",
		ipad_hunt_not_succesfull_added: "Non è stato possibile aggiungere l'attività Ipad Hunt",
		challenge_activated: "Sfida Attivata",
		points_updated: "Punti Aggiornati",
		time_updated: "Tempo Aggiornato",
		correctly_scored: "Punteggiato correttamente",
		incorrectly_scored: "Non è stato possibile punteggiare correttamente",
		team: "Squadra",
		action_updated_ok: "Attività Action Challenge aggiornata correttamente",
		action_updated_not_ok: "Non è stato possibile aggiornare l'attività Action Challenge",
		action_added_ok: "Attività Action Challenge aggiunta correttamente",
		action_added_not_ok: "Non è stato possibile aggiungere l'attività Action Challenge",
		route_created: "Ruta Creata",
		route_deleted: "Ruta Cancellata",
		route_saved: "Ruta Salvata",
		saved: "Salvato",
		select_category: "Seleziona una categoria",
		must_select: "Devi selezionare top1 e top 2",
		vote_sent: "Voto inviato",
		vote_error: "Errore durante il voto",
		correct_score: "Punteggio corretto",
		incorrect_score: "Non è stato possibile punteggiare correttamente",
		game_reactivated: "Gioco riattivato",
		game_finished: "Gioco terminato",
		write_quesiton: "Scrivi una domanda",
		event_deleted: "Evento cancellato",
		select_activity: "Devi selezionare l'attività",
		event_created: "Evento creato",
		event_updated: "Evento modificato",
		event_not_created: "Impossibile creare l'evento",
		utq_updated: "Attività Rally aggiornata correttamente",
		utq_not_updated: "Impossibile aggiornare l'attività Rally",
		url_copied: "URL copiata",
		url_error: "Errore durante la copia dell'URL",
		error_deleting_event: "Impossibile eliminare l'evento",
		reopened: "Riaperto",
		finished: "Finalizzato",
		cancelled: "Annullato",
		closed_booking: "Prenotazione Chiusa",
		canceled_booking: "Prenotazione Annullata",
		file_removed: "File rimosso",
		upload_file: "Carica file",
		file_uploaded: "File caricato",
		error_upload: "Impossibile caricare il file",
		no_id_model: "Devi salvare il modulo prima di caricare file",
		no_files_readonly: "Al momento non ci sono file da scaricare.",
		favorite_challenge_added: "Sfida aggiunta ai preferiti",
		favorite_challenge_removed: "Sfida rimossa dai preferiti",
		next_act: "Caso successivo",
		added_points: "Punti aggiunti",
		added_time: "Tempo aggiunto",
		given_object: "Oggetto dato",
		given_information: "Informazioni fornite",
		write_question: "Scrivi una domanda"
	},
	player_views: {
		event: {},
		home: {
			user_registered: "Utente registrato",
			active_events: "Visualizza eventi attivi",
			insert_code: "Inserisci codice evento // team",
			qr_scan: "Scans QR",
			code_event: "Codice evento",
			code_team: "Codice squadra",
			event_not_exist: "L'evento non esiste",
			team_not_exist: "La squadra non esiste"
		},
		player_view: {}
	},
	public_views: {
		tapas: {
			presentation_tapas: {
				end: "Fine della presentazione"
			},
			ranking_tapas: {
				round_ends: "Ronda finalizza",
				team_turn: "Turno squadra",
				choice_type: "Tipo scelta",
				choice_round: "Ronda scelta",
				total_round: "Ronda totale",
				time_preparation: "Tempo di preparazione"
			},
			results_tapas: {}
		},
		utq: {
			ranking_utq: {
				round_ends: "Ronda finalizza",
				points_upper: "PUNTI",
				points_abbr: "pts",
				challenge_upper: "SFIDA",
				challenges_done: "Sfide",
				team_upper: "TEAM",
				team_fallback: "Squadra",
				position_upper: "POSIZIONE",
				round_time_left: "Tempo rimasto per il turno",
				no_teams: "Non ci sono ancora squadre in classifica"
			},
			results_utq: {
				team_upper: "TEAM",
				position_upper: "POSIZIONE",
				points_upper: "PUNTI"
			}
		},
		collabo: {
			last_buildings: "Ultimi Edifici",
			buildings: "Edifici",
			join_event: "Unirmi all'evento",
			next_objective: "Prossimo obiettivo",
			objective: "Obiettivo",
			all_objectives_completed: "Tutti gli obiettivi completati",
			objective_completed: "È stato completato l'obiettivo",
			new_buildings_unlocked: "NUOVI EDIFICI SBLOCCATI",
			skyscraper_unlocked: "Ora potete costruire il grattacielo",
			ranking_title_default: "Ranking"
		},
		actionChallenge: {
			ranking_action_challenge: {
				press_button_view_ranking: "Premi il pulsante per vedere il ranking",
				view_ranking: "Vedi ranking"
			}
		},
		team_picker: {
			title: "Lista delle Squadre",
			tooltip: "Genera un link per consentire alle squadre di scegliere in quale squadra vogliono partecipare",
			subtitle: "Trova e visualizza squadre cercando per nome o ID",
			search_placeholder: "Cerca per nome o ID di squadra...",
			no_teams_found: "Nessuna squadra trovata",
			try_adjusting_search: "Prova a modificare la tua ricerca",
			no_teams_available: "Nessuna squadra disponibile",
			showing_results: "Mostrando {count} di {total} squadre",
			points: "Punti",
			id: "ID"
		},
		event_lobby: {
			join_game: "Unisciti al gioco",
			player_photo_optional: "Foto del giocatore (Facoltativa)",
			title: "Sala dell'Evento"
		}
	},
	ipadHunt: {
		initial_position: "Posizione iniziale",
		finish_position: "Posizione finale",
		ipadHunt_player: {
			must_challenge: "Sfida obbligatoria",
			modal_password: "Inserisci la password che ti fornirà il membro dello staff",
			modal_error_download_title: "Contenuto non salvato",
			modal_error_download_text: "Riprova a scaricare il contenuto",
			modal_download_content_title: "Download del contenuto",
			modal_download_content_text: "Download del contenuto",
			modal_error_location_title: "La localizzazione non è disponibile",
			modal_error_location_text: "Attiva i permessi di localizzazione o contatta l'organizzatore dell'evento.",
			content_correct: "Contenuto scaricato correttamente",
			content_incorrect: "Ci sono errori nel contenuto, scarica di nuovo",
			delete_content: "Elimina il contenuto e riscarica",
			test_camera: "Prova la fotocamera",
			answer_send: "La tua risposta è stata registrata correttamente. Nei prossimi minuti riceverai i punti corrispondenti.",
			match: "Collegare",
			take_photo: "Fai foto",
			take_video: "Registra video",
			error_wrong_password: "La password non è corretta",
			error_no_answer: "Non è stata rilevata alcuna risposta",
			error_order: "Devi ordinare le risposte",
			modal_test_title: "TEST",
			modal_test_localization_correct: "Localizzazione corretta",
			modal_test_localization_incorrect: "La localizzazione non è disponibile",
			modal_test_ok: "Test corretto",
			reload_app: "Aggiorna applicazione",
			challenge_camera: "Camera sfida",
			modal_challenge_title: "TEST",
			modal_challenge_localization_correct: "Localizzazione corretta",
			modal_challenge_localization_incorrect: "Localizzazione non disponibile",
			modal_challenge_ok: "Reto completato correttamente",
			reset_challenge: "Reiniciare la sfida iniziale",
			challenge_reset: "Sfida reiniziata correttamente",
			no_active_challenge: "Non è stata trovata nessuna sfida attiva",
			show_start_challenges: "Mostra Sfide Iniziali",
			start_challenges_shown: "Sfida(e) verranno mostrate nuovamente",
			no_start_challenges: "Non sono state trovate sfide iniziali",
			scan_qr: "Scansiona QR",
			qr_scanned: "Codice QR Scansionato!",
			error_invalid_qr: "Codice QR non valido",
			error_challenge_not_found: "Sfida non disponibile",
			error_challenge_already_done: "Questa sfida è già stata completata",
			challenges_blocked: "Sfide bloccate",
			challenges_blocked_message: "Il monitor ha bloccato tutte le sfide. Si prega di attendere il sblocco delle sfide."
		},
		game_master_ranking: {
			name: "Nome",
			points: "Punti",
			challenges_done: "Sfide completate",
			last_challenge: "Ultima sfida"
		}
	},
	actionChallenge: {
		actionChallenge_player: {
			final_images: "Immagini del gioco",
			already_done: "Hai già completato questo test",
			quiz_already_done: "Hai già completato questo questionario",
			category_completed: "Hai già completato tutti i questionari di questa categoria",
			until: "Fino a",
			points: "Punti",
			coins: "monete",
			coins_won: "Monete guadagnate:",
			audio_error: "Il tuo browser non supporta il formato audio.",
			need_material: "In questa sfida hai bisogno di materiale",
			continue: "CONTINUA",
			send_response: "INVIA RISPOSTA",
			correct_response: "RISPOSTA CORRETTA",
			correct_responses: "RISPOSTE CORRETTE",
			incorrect_response: "RISPOSTA INCORRETTA",
			money_won: "Denaro vinto:",
			response: "Risposta",
			multiple_answers_hint: "( PUOI SELEZIONARE PIÙ RISPOSTE )",
			btn_match: "Abbina",
			successes: "Risultati positivi",
			similarity: "La parola corrisponde per un {similarity_percentage}% alle parole corrette",
			category_no_elements: "Non ci sono elementi in questa categoria",
			not_started: "L'EVENTO NON È ANCORA INIZIATO",
			challenge_warning: "Dopo aver acquistato una sfida, vai a prendere il materiale nel negozio per completarla.",
			pick_material: "VAI A PRENDERE IL MATERIALI NEL NEGOZIO PER INIZIARE QUESTA SFIDA",
			challenge_send: "LA RISPOSTA È STATI INVIATA E SARÀ VALUTATA DAL MONITORE",
			return_material: "RESTITUISCI IL MATERIALI AL NEGOZIO PER SELEZIONARE LA SEGUENTE SFIDA",
			points_won: "Punti guadagnati",
			wrong_answer: "RISPOSTA INCORRETTA",
			game_finished: "LA PARTITA È FINITA",
			return_material_finish: "RESTITUISCI IL MATERIALI DELLA SFIDA AL NEGOZIO",
			no_material: "Al momento non ci sono materiali sufficienti per fare questa sfida",
			no_money: "Non hai soldi sufficienti per acquistare questa sfida",
			shop: "Negozio",
			obejcts_buy: "Materiale acquistato",
			quantity: "Quantità",
			modal_buy_text: "Acquista {object} per {dinero}$",
			error_item_buy_no_money: "Non hai abbastanza soldi",
			error_item_buy_no_stock: "Non c'è più stock",
			error_item_buy_can_not_more: "Non puoi acquistare più materiali di questo",
			ok_item_buy: "Materiale acquistato, puoi già raccoglierlo",
			construction_name: "Nome della costruzione",
			construction_photo: "Foto della costruzione",
			total_points: "Punti totali",
			ranking_hidden: "La classifica è nascosta",
			ranking_cooperative: "Classifica cooperativa",
			ranking_slides: "Diapositiva"
		},
		ranking_action_challenge: {
			press_button_view_ranking: "Premi il pulsante per vedere la classifica",
			view_ranking: "Vedi classifica"
		}
	},
	cluedo_ai: {
		cluedo_ai_player: {
			game_paused: "Il gioco è in pausa, aspetta che il monitor lo riprenda.",
			evaluated: "Valutato le risposte",
			upload_team_picture: "Carica foto di squadra",
			no_picture: "Non c'è foto di squadra",
			scan_qr_code: "Scansiona QR",
			key_information: "Informazioni chiave",
			key_information_missing: "Informazioni chiave mancanti",
			no_key_information: "Nessuna informazione chiave",
			objects: "Oggetti",
			characters: "Personaggi",
			game_intro: "Introduzione al caso",
			question: "Domanda",
			game_finished: "Gioco terminato",
			questions_modified: "Risposte non salvate",
			init_conversation: "Invia un messaggio per iniziare la conversazione con {character_name}",
			interrogate: "Interrogare",
			explore: "Esplora",
			view_intro: "Guarda introduzione",
			send_answer: "Salva risposte",
			conclusions: "Conclusioni",
			not_started: "Il gioco non è ancora iniziato",
			updated: "Risposte aggiornate",
			answers_sent: "Risposte inviate",
			answers_not_sent: "Non è stato possibile inviare le risposte",
			no_answer: "Non c'è risposta",
			new_object_unlocked: "Nuovo oggetto sbloccato",
			new_character_unlocked: "Nuovo personaggio sbloccato",
			model_3d: "Modello 3D",
			answer_placeholder: "Risposta...",
			voice_record: "Parla (premi per registrare e di nuovo per trascrivere)",
			voice_stop: "Ferma la registrazione e trascrivi",
			voice_listening: "Ascoltando…",
			voice_transcribing: "Trascrivendo audio…",
			voice_error_microphone_unavailable: "Il microfono non è disponibile su questo dispositivo.",
			voice_error_microphone_denied: "Permesso del microfono negato.",
			voice_error_empty_recording: "Non è stato registrato audio.",
			voice_error_empty_transcript: "Non è stato compreso l'audio.",
			voice_error_transcription_failed: "Non è stato possibile trascrivere l'audio. Riprova.",
			found_object: "HAI TROVATO UN OGGETTO",
			found_character: "HAI TROVATO UN PERSONAGGIO",
			error_invalid_qr: "Codice QR non valido",
			error_wrong_case_title: "Caso errato",
			error_wrong_case_message: "Questo codice QR appartiene a un altro caso. Possono essere scansionati solo codici QR del caso attivo in questo momento."
		}
	},
	collabo: {
		player_collabo: {
			seconds_to_show_error_modal: "Attendi {seconds} secondi",
			error: "Errore",
			incorrect_answer: "Risposta incorretta. Per favore, riprova.",
			correct: "Corretto",
			correct_answer: "Risposta corretta",
			last_buildings: "Ultime Costruzioni",
			buildings: "Costruzioni",
			join_challenge: "Sono in {challenge_name}",
			go_zone: "VAI ALLA ZONA DELLA SFIDA <span class='text-primary'>{challenge_name}</span> PER INIZIARE.",
			confirm_join_challenge: "Confermi di essere nel roll-up di <span class='text-primary'>{challenge_name}</span>?",
			players_joined: "Giocatori",
			cancel: "Annulla",
			confirm_join: "Conferma",
			points_added: "Punti aggiunti correttamente",
			points_add_error: "Errore nell'aggiungere punti",
			challenge_joined: "Ti sei unito alla sfida correttamente",
			challenge_join_error: "Errore nell'unirsi alla sfida",
			construction_in_progress: "Costruzione In Corso",
			material_needed: "Materiale Necessario",
			delete_construction: "Elimina Costruzione",
			cancel_construction: "Annulla Costruzione",
			join_construction: "QR per unirsi",
			material_in_construction: "Materiale in costruzione:",
			available: "Disponibile",
			in_construction: "In Costruzione",
			player_join: "Unirsi Giocatore",
			helpToBuild: "Aiutare a Costruire",
			build: "Costruire",
			not_enough_materials: "Edifici Insufficienti",
			build_construction: "Costruire Edificio",
			build_construction_description: "Vuoi iniziare a costruire questo edificio?",
			new_material_received: "Nuovo Materiale Ricevuto",
			accept: "Accettare",
			join_construction_description: "Scansiona il codice QR per unirti a questa costruzione",
			delete_construction_description: "Sei sicuro di voler eliminare questa costruzione?",
			delete: "Elimina",
			cancel_construction_description: "Sei sicuro di voler annullare l'aiuto con questa costruzione?",
			construction_finished: "Costruzione Completata",
			construction_finished_description: "La costruzione è stata completata!",
			success_construction: "Costruzione Avvenuta con Successo",
			building_id: "ID dell'Edificio",
			built_by: "COSTRUITO DA",
			just_now: "Ora",
			some_minutes_ago: "Fa {minutes} minuti",
			more_than_hour_ago: "Fa meno di un'ora",
			minute_ago: "MIN",
			minutes_ago: "MIN",
			hour_ago: "H",
			hours_ago: "H",
			day_ago: "GIORNO",
			days_ago: "GIORNI",
			material_accepted: "Material accettato correttamente",
			material_accept_error: "Errore nell'accettare il materiale",
			material_added: "Materiale aggiunto correttamente",
			material_add_error: "Errore nell'aggiungere il materiale",
			construction_canceled: "Costruzione annullata correttamente",
			construction_cancel_error: "Errore nell'annullare la costruzione",
			construction_deleted: "Costruzione eliminata correttamente",
			construction_delete_error: "Errore nell'eliminare la costruzione",
			construction_started: "Costruzione iniziata correttamente",
			construction_error: "Errore nell'iniziare la costruzione",
			enter_number: "Inserisci numero",
			submit: "Invia",
			select_color: "Seleziona colore",
			select_color_first: "Per favore, seleziona un colore prima",
			saving: "Salvataggio...",
			no_recipe: "Nessuna ricetta disponibile",
			your_components: "I tuoi Componenti",
			component_updated: "Componente aggiornato correttamente",
			matrix_updated: "Matrice aggiornata correttamente",
			matrix_update_error: "Errore durante l'aggiornamento della matrice",
			your_resources: "Le tue Risorse",
			or_enter_code: "O inserisci il codice:",
			enter_3_letters: "Inserisci 3 lettere",
			validate_code: "Convalida Codice",
			invalid_code: "Codice non valido",
			code_not_found: "Il codice non corrisponde a nessuna costruzione disponibile",
			code_label: "Codice:",
			objective_done: "Obiettivo raggiunto",
			teams_in_construction: "Squadre in costruzione",
			participants_in_construction: "Partecipanti in costruzione",
			leading_team: "Leader"
		}
	},
	tapas: {
		change_main_ingredient: "Cambia ingrediente principale",
		change_time: "Modifica tempo",
		tapas_player: {
			new_challenge: "Nuova sfida",
			change_name: "Cambia nome",
			time_choose: "Tempo per scegliere",
			presentation_in: "Presentazione in",
			final_presentation: "Presentazione finale",
			default_keyword: "Parola chiave",
			dish_name_PC: "Nome della paella",
			dish_name_Tapas: "Nome della tapa",
			dish_name_MS: "Nome della sangria",
			dish_name: "Nome di ",
			dish_photo: "Foto di ",
			dish_photo_PC: "Foto della paella",
			dish_photo_Tapas: "Foto della tapa",
			dish_photo_MS: "Foto della sangria",
			available_money: "Denaro disponibile",
			choose_ingredient: "Scegliere ingrediente",
			team_choosing: "Squadra in scelta",
			choose_rice: "Scegliere riso",
			choose_plates: "Scegliere piatti",
			choose_plates_rices: "Scegliere piatti/risi",
			choose_decoration: "Scegliere decorazione",
			change_team_name: "Cambia nome squadra",
			buy_confirm: "Conferma acquisto",
			meal_photo: "Foto del pasto",
			exit_event: "Esci dall'evento",
			answer_correct: "La risposta è corretta",
			answer_incorrect: "La risposta è incorretta",
			name_changed: "Nome cambiato",
			name_sent: "Nome inviato",
			item_purhased: "Oggetto acquistato, puoi già andarlo a ritirare nel negozio",
			no_unit: "Nessuna unità",
			password_incorrect: "La password non è corretta",
			item_purchased: "Utensile acquistato",
			item_already_purchased: "Il tuo team ha già acquistato questo articolo",
			team_photo: "Foto del team",
			ingredient_history: "Cronologia degli Ingredienti",
			current_ingredients: "Ingredienti Attuali",
			shop_items: "Articoli del Negozio",
			team_info: "Informazioni sul Team",
			team_name: "Nome del Team",
			current_money: "Denaro Attuale",
			not_set: "Non impostato"
		}
	},
	modals: {
		upload_photo: {
			change_camera: "Cambia fotocamera",
			upload_photo: "Carica foto",
			photo_success: "Foto inviata"
		}
	},
	stores: {
		tapas: {
			main_ingredient: "Ingrediente principale",
			global_winner: "Globale",
			flavour_winner: "Sapore",
			presentation_winner: "Present.",
			defense_winner: "Difesa",
			money_winner: "Denaro",
			photo_tapa: "F. TAPA",
			photo_team: "F. TEAM",
			tapa: "TAPA",
			position: "POSIZIONE",
			points: "PUNTI"
		}
	},
	erp: {
		booking: {
			reservation: "Riserva",
			client_link: "Link cliente",
			changes_pending: "Cambiamenti in attesa di validazione",
			changes_sent_title: "Modifiche salvate",
			changes_sent_detail: "Le tue modifiche sono state salvate e inviate correttamente. Ora sono in attesa di validazione.",
			changes_sent_no_changes: "Non c'erano nuove modifiche da inviare.",
			calendar: {
				vendedor: "Venditore",
				produccion: "Produzione",
				select_vendedor: "Selezionare venditore",
				select_produccion: "Selezionare produzione",
				calendar: "Calendario",
				filters: "Filtri",
				calendar_filters: "Filtri del calendario",
				production_details: "Dettagli produzione",
				configure_fields: "Configurare campi",
				crm_id: "ID CRM",
				pax: "Pax",
				language: "Lingua",
				fundae: "FUNDAE",
				staff_number: "Numero di monitori",
				teams_number: "Numero di squadre",
				bookings: "Prenotazioni",
				budgets: "Budget",
				gamemasters: "GM",
				accepted: "ACCETTATO",
				to_check: "DA CONTROLARE"
			}
		},
		user_settings: {
			title: "Impostazioni Utente",
			change_password: "Cambia Password",
			new_password: "Nuova Password",
			enter_new_password: "Inserisci la nuova password",
			confirm_password: "Conferma Password",
			confirm_new_password: "Conferma la nuova password",
			change_password_button: "Cambia Password",
			change_language: "Cambia Lingua",
			language: "Lingua",
			select_language: "Seleziona una lingua",
			change_language_button: "Cambia lingua",
			password_required: "Per favore inserisci la nuova password",
			password_min_length: "La password deve contenere almeno 8 caratteri",
			confirm_password_required: "Per favore conferma la nuova password",
			passwords_not_match: "Le password non corrispondono",
			password_changed_success: "Password cambiata con successo.",
			password_change_error: "Errore durante la modifica della password. Per favore riprova.",
			form_errors: "Per favore correggi gli errori nel modulo.",
			spanish: "Spagnolo",
			english: "Inglese",
			language_required: "Per favore seleziona una lingua",
			language_updated_success: "Lingua aggiornata con successo.",
			language_update_error: "Errore durante l'aggiornamento della lingua. Per favore riprova.",
			select_valid_language: "Si prega di selezionare una lingua valida."
		},
		configuration: {
			integrations: {
				title: "Integrazioni",
				subtitle: "Collega strumenti esterni alla tua organizzazione.",
				connected: "Connesso",
				not_connected: "Non connesso",
				connect: "Connetti",
				disconnect: "Disconnetti",
				company: "Azienda",
				connected_as: "Connesso come",
				api_token: "API token",
				api_token_placeholder: "Incolla qui il tuo API token di Pipedrive",
				api_token_help: "In Pipedrive: Preferenze personali → API → Personal API token.",
				slack_channels_title: "Canali Slack",
				pipedrive_title: "Pipedrive",
				pipedrive_description: "Collega Pipedrive per associare opportunità e prenotazioni al tuo CRM.",
				pipedrive_connected: "Pipedrive connesso",
				pipedrive_not_connected: "Pipedrive non connesso",
				pipedrive_connect_success: "Pipedrive connesso correttamente",
				pipedrive_connect_error: "Impossibile connettere Pipedrive. Controlla l'API token.",
				pipedrive_disconnect_success: "Pipedrive disconnesso",
				pipedrive_disconnect_error: "Impossibile disconnettere Pipedrive"
			},
			organization: {
				slack_configuration: "Configurazione di Slack",
				slack_install_description: "Installa l'app di Slack per ricevere notifiche sugli eventi.",
				slack_connected: "Slack connesso",
				slack_not_connected: "Slack non connesso",
				event_notifications_channel: "Canale di notifiche degli eventi",
				staff_notifications_channel: "Canale di notifiche per il personale",
				select_channel: "Seleziona canale",
				refresh_channels: "Aggiorna canali",
				save_slack_config: "Salva configurazione di Slack",
				slack_config_saved: "Configurazione di Slack salvata",
				error_saving_slack_config: "Errore durante il salvataggio della configurazione di Slack",
				channels_refreshed: "Canali aggiornati",
				error_refreshing_channels: "Errore durante l'aggiornamento dei canali",
				initial_position: "Posizione iniziale per eventi",
				initial_position_label: "Posizione iniziale",
				search_location: "Cerca posizione...",
				error_loading_places: "Errore nel caricamento del servizio di luoghi",
				link_app: "Collegamento all'applicazione",
				testing_link: "Collegamento di test giochi Online",
				testing_link_description: "Condividi questo collegamento con i clienti in modo che possano controllare la loro connessione e la configurazione del dispositivo prima dell'evento.",
				booking_agent: "Agente IA",
				booking_agent_description: "Quando è attivo, lo staff può richiedere su ogni prenotazione un'analisi con l'Agente IA.",
				booking_agent_enabled: "Attiva Agente IA sulle prenotazioni",
				booking_agent_extra_prompt: "Istruzioni extra del prompt",
				booking_agent_extra_prompt_help: "Vengono aggiunte al prompt di base del sistema. Usale per checklist o regole della tua organizzazione.",
				booking_agent_extra_prompt_placeholder: "Es.: Controllare sempre il contatto on-site, il menu confermato e il parcheggio.",
				open: "Aprire",
				organization_url: "URL dell'organizzazione",
				copy: "Copiare",
				users: "Utenti",
				create_new_user: "Crea nuovo utente",
				edit_user: "Modifica utente",
				name: "Nome",
				enter_name: "Inserisci il nome",
				role: "Ruolo",
				cancel: "Annulla",
				save: "Salva",
				email: "Email",
				enter_email: "Inserisci l'email",
				password: "Password",
				enter_password: "Inserisci la password",
				confirm_password: "Conferma Password",
				confirm_password_placeholder: "Conferma la nuova password",
				create: "Crea",
				confirm_deletion: "Conferma Cancellazione",
				delete_user_confirmation: "Sei sicuro di voler eliminare l'utente {name}?",
				delete: "Elimina",
				organization_qr_code: "Codice QR dell'Organizzazione",
				administrator: "Amministratore",
				facilitator: "Facilitatore",
				edit: "Modifica",
				actions: "Azioni",
				url_copied: "URL copiato negli appunti",
				user_updated: "Utente aggiornato con successo",
				error_updating_user: "Errore durante l'aggiornamento dell'utente",
				user_created: "Utente creato con successo",
				error_creating_user: "Errore durante la creazione dell'utente",
				user_deleted: "Utente eliminato con successo",
				error_deleting_user: "Errore durante l'eliminazione dell'utente",
				select_role: "Seleziona un ruolo",
				available_languages: "Lingue disponibili",
				select_languages: "Seleziona le lingue",
				default_language: "Lingua predefinita",
				select_default_language: "Seleziona la lingua predefinita",
				at_least_one_language_required: "Deve essere selezionata almeno una lingua",
				make_all_pdfs: "Genera tutti i PDF",
				make_all_pdfs_cooldown: "La generazione del PDF è già in corso. Puoi ricominciare 45 minuti dopo l'ultima esecuzione.",
				make_all_pdfs_started: "La generazione del PDF è iniziata.",
				make_all_pdfs_error: "Impossibile avviare la generazione del PDF. Per favore, riprova.",
				personalization: "Personalizzazione",
				monitor_info: "Informazioni sul monitor",
				field_label: "Etichetta del campo",
				field_type: "Tipo di campo",
				field_options: "Opzioni del campo (separate da virgole)",
				visible_to_staff: "Visibile al personale",
				required: "Obbligatorio",
				active: "Attivo",
				add_field: "Aggiungi campo",
				booking_defaults: "Campi predefiniti di prenotazione",
				booking_default_field: "Campo di prenotazione",
				booking_default_value: "Valore predefinito",
				booking_default_files: "File template",
				booking_default_save_first_upload: "Salva la configurazione prima di caricare i file template.",
				booking_default_json_hint: "Inserisci JSON valido (array o oggetto).",
				fundae_enabled: "Attiva i campi FUNDAE",
				contracts_enabled: "Attiva i contratti nelle prenotazioni",
				contracts: "Contratti",
				booking_custom_fields: "Campi personalizzati della prenotazione",
				booking_custom_fields_hint: "Questi campi compaiono nella prenotazione e possono essere usati come variabili del contratto.",
				contract_template: "Modello del contratto",
				contract_template_hint: "Scrivi il contratto e inserisci variabili della prenotazione o campi cliente dove vuoi. I campi cliente non compaiono da soli: vanno inseriti nel testo.",
				insert_booking_variable: "Variabile o campo",
				insert_variable: "Inserisci variabile",
				add_client_field: "Crea campo cliente",
				client_field_button_tooltip: "Crea un campo che il cliente compilerà e lo inserisce nel contratto alla posizione del cursore.",
				client_field_tooltip: "Testo di aiuto (tooltip)",
				contract_client_fields: "Campi cliente",
				contract_client_fields_hint: "Campi che compila il cliente. Creali qui e inserisci la loro variabile nel testo del contratto dove vuoi.",
				contract_template_expand: "Mostra testo del contratto",
				contract_template_collapse: "Riduci testo del contratto",
				client_field_option_prefix: "Cliente",
				signing_fields_title: "Campi per firmare",
				signing_fields_hint: "Nome e firma sono sempre richiesti alla firma. Qui aggiungi solo campi di testo extra (es. documento).",
				signing_field_required: "Obbligatorio",
				add_signing_text_field: "Aggiungi campo di testo",
				signing_type_name: "Nome",
				signing_type_signature: "Firma disegnata",
				signing_type_text: "Testo",
				signature_template_title: "Paragrafo di firma",
				signature_template_hint: "Testo aggiunto al contratto quando il cliente firma. Inserisci variabili di firma e dei campi di firma.",
				insert_signature_variable: "Variabile di firma",
				insert_into_signature: "Inserisci nel paragrafo di firma",
				signature_var_signer_name: "Nome del firmatario",
				signature_var_signed_datetime: "Data e ora",
				signature_var_signed_date: "Data",
				signature_var_signed_time: "Ora",
				signature_var_signature_image: "Immagine della firma",
				signature_var_signed_by_label: "Etichetta «Firmato da» (lingua prenotazione)",
				signature_var_date_label: "Etichetta «Data e ora» (lingua prenotazione)",
				signature_var_company_signer_name: "Nome firmatario azienda",
				signature_var_company_signature_image: "Firma dell'azienda",
				company_signature_title: "Firma dell'azienda",
				company_signature_hint: "Nome e firma della tua azienda. Vengono aggiunti automaticamente a tutti i contratti firmati.",
				company_signer_name: "Nome del firmatario (azienda)",
				company_signature_draw: "Disegna firma azienda",
				company_signature_clear: "Rimuovi firma azienda",
				booking_field_type_text: "Testo",
				booking_field_type_textarea: "Testo lungo",
				booking_field_type_number: "Numero",
				booking_field_type_date: "Data",
				booking_field_type_select: "Selezione",
				booking_field_type_checkbox: "Casella",
				notifications: "Notifiche",
				notifications_channels: "Canali",
				notifications_channel_email: "Email",
				notifications_channel_whatsapp: "WhatsApp",
				notifications_list: "Notifiche",
				notifications_enabled: "Attiva",
				notifications_channels_for_event: "Invia tramite",
				notifications_trigger_monitor_activity_offer: "Quando un monitor riceve un'offerta di attività",
				notifications_trigger_monitor_accept_reject: "Quando un monitor accetta o rifiuta un'attività",
				notifications_whatsapp_inbound: "Risposta automatica di WhatsApp",
				notifications_whatsapp_inbound_hint: "Testo che viene inviato quando un monitor scrive al numero di WhatsApp.",
				notifications_event_list: "Notifiche di evento",
				notifications_event_hint: "Avvisi programmati riguardo all'inizio dell'evento, da 3 giorni prima a 3 giorni dopo.",
				notifications_event_add: "Aggiungi notifica",
				notifications_event_edit: "Modifica notifica",
				notifications_event_name: "Nome",
				notifications_event_name_required: "Ogni notifica di evento necessita di un nome.",
				notifications_event_when: "Quando",
				notifications_event_when_before: "Prima dell'evento",
				notifications_event_when_after: "Dopo l'evento",
				notifications_event_days: "Giorni",
				notifications_event_hours: "Ore",
				notifications_event_minutes: "Minuti",
				notifications_event_message: "Testo",
				notifications_event_recipients: "Destinatari",
				notifications_event_recipient_sales_responsible: "Responsabile vendite",
				notifications_event_recipient_production_responsible: "Responsabile produzione",
				notifications_event_recipient_responsible_monitor: "Responsabile monitor",
				notifications_event_recipient_monitors: "Monitor",
				field_type_text: "Testo",
				field_type_select: "Selezione",
				field_type_multiselect: "Selezione multipla",
				field_type_checkbox: "Casella",
				field_type_phone_communications: "Telefono comunicazioni"
			},
			credit_consumption: {
				title: "Consumo di crediti",
				subtitle: "Uso di crediti dell'organizzazione, totali di fatturazione e stato di pagamento.",
				entries: "Registri",
				total_credits: "Crediti totali",
				paid_amount: "Importo pagato",
				pending_amount: "Importo pendente",
				filters: "Filtri",
				date_from: "Data da",
				date_to: "Data a",
				activity_type: "Tipo di attività",
				payment_status: "Stato del pagamento",
				apply: "Applica",
				consumption_details: "Dettagli sul consumo",
				rows_count: "{count} righe",
				col_date: "Data",
				col_event: "Evento",
				col_activity: "Attività",
				col_credits: "Crediti",
				col_unit_price: "Prezzo unitario",
				col_amount: "Importo",
				col_paid: "Pagato",
				status_paid: "Pagato",
				status_pending: "In attesa",
				empty_state: "Non ci sono consumi di crediti con i filtri attuali.",
				filter_all: "Tutti",
				filter_paid: "Pagato",
				filter_pending: "In attesa",
				all_activities: "Tutte le attività",
				activity_fallback: "Attività {id}",
				load_failed: "Impossibile caricare il consumo di crediti."
			}
		}
	},
	events: {
		active_events: "Eventi attivi",
		event: "Attività",
		game: "App",
		day: "Data",
		actions: "Azioni",
		view_event: "Visualizza attività",
		enter: "Entrare",
		finish: "Finalizzare",
		reopen: "Riaprire",
		delete_event: "Eliminare evento",
		are_you_sure: "Sei sicuro?",
		accept: "Accettare",
		cancel: "Annullare",
		no_content: "Nessun contenuto",
		no_content_in_activity: "Nessun contenuto in questa attività",
		edit: "Modificare",
		download: "Scaricare",
		delete: "Eliminare",
		search_name: "Cerca per nome..."
	},
	client: {
		budgets: "Budget",
		bookings: "Prenotazioni",
		billed: "Fatturato"
	},
	qr_scanner: {
		camera_permission_denied: "ERROR: Permesso della fotocamera negato",
		no_camera_found: "ERROR: Nessuna fotocamera trovata sul dispositivo",
		unable_to_start_camera: "ERROR: Impossibile avviare la fotocamera"
	},
	map: {
		search_address: "Cerca un'indirizzo...",
		locate_button: "Centrar mappa",
		switch_map_type: "Cambia tipo di mappa"
	},
	musicalBingo: {
		staff: {
			skip_challenge: "Salta sfida",
			song_challenge: "Canzone della sfida",
			song_post_challenge: "Canzone del post sfida",
			winner_team: "Squadra vincente",
			challenge_explaining: "Spiegando la sfida",
			volume_up: "Volume +",
			volume_down: "Volume -",
			command_send: "Comando inviato",
			next_step_send: "Passo successivo inviato",
			controls: "Controlli",
			status: "Stato",
			start_game: "Inizia gioco",
			waiting_game: "In attesa del gioco",
			waiting_set: "Selezionando Bingo",
			next_step: "Passo successivo",
			start_bingo: "Inizia Bingo",
			game_start_soon: "Bingo pronto per iniziare",
			start_bingo_public: "Inizia Bingo",
			playing_song: "Riproducendo la canzone",
			result_song: "Risultato canzone",
			pause_song: "Pausa canzone",
			resume_song: "Riprendi canzone",
			repeat_song: "Ripeti canzone",
			song_result: "Risultato canzone",
			playing_challenge: "Riproducendo sfida",
			remaining_time: "Tempo rimanente",
			team_answers: "Risposte delle squadre",
			correct_answers: "Risposte corrette",
			players: "giocatori",
			song: "Canzone",
			next_image: "Immagine successiva",
			bingo_select: "Selezionare Bingo",
			final_ranking: "Finalizza ranking",
			final_photo: "Finalizza foto",
			bingo_done: "Bingo completato",
			finish_game: "Finalizzare bingo",
			bingo_finished: "Bingo finito",
			stop_bingo: "Fermare bingo",
			live_view: "Vista dal vivo",
			exclude_teams: "Squadre che non devono vincere questo bingo",
			exclude_teams_placeholder: "Seleziona squadre (opzionale)",
			exclude_teams_all_error: "Almeno una squadra deve poter vincere"
		},
		public_view: {
			re_take_photo: "Rifare foto",
			select_option: "Seleziona l'opzione più votata",
			quiz_results: "Risultati del quiz",
			challenge_results: "Risultati delle sfide",
			quiz: "Quiz",
			fill: "Compila la frase",
			two_vs_two: "Sfida a squadre",
			one_vs_all: "Sondaggio di squadra",
			photo: "Foto",
			waiting_game: "Aspettando il gioco",
			selecting_bingo: "Selezionando Bingo",
			bingo_start_soon: "Il Bingo inizierà a breve",
			playing: "Indovina la canzone",
			ranking: "Classifica",
			seconds: "secondi",
			points: "punti",
			answer_sent: "Risposta inviata",
			answer_not_sent: "Non è stato possibile inviare la risposta",
			send_answer: "Invia risposta",
			remaining_time: "Tempo rimanente",
			team_answers: "Risposte delle squadre",
			correct_answers: "Risposte corrette",
			players: "giocatori",
			photo_show: "Foto delle squadre",
			go_to_stage: "Un rappresentante del tuo team deve salire sul palco",
			go_to_stage_all: "Che salga tutta la squadra sul palco",
			this_groups_to_stage: "Aspettando che i team salgano sul palco",
			challenge_start_soon: "Aspetta che i rappresentanti scelti salgano sul palco",
			turn_of_team: "Turno del team",
			vote_of_team: "Ora di votare",
			placement: "Team in posizionamento",
			draw: "Pareggio",
			fill_write_answer: "Compilare la risposta",
			fill_answer: "Compilare la risposta",
			quiz_write_answer: "Rispondendo al quiz",
			photo_write_answer: "Inviando le foto",
			upload_photo: "Scattare una foto",
			photo_saved: "Foto salvata",
			fill_answer_placeholder: "Scrivi la risposta"
		},
		ranking_musical_bingo: {
			press_button_view_ranking: "Premi il pulsante per vedere il ranking",
			view_ranking: "Visualizza il ranking"
		},
		player: {
			bingo_start_soon: "Il bingo inizierà a breve",
			selecting_bingo: "Selezionando bingo",
			no_picture: "Nessuna foto della squadra",
			upload_team_picture: "Carica foto della squadra",
			not_started: "L'attività non è ancora iniziata",
			photo_show: "Foto delle squadre",
			song_marked: "Canzone contrassegnata",
			answered: "Risposto",
			correct_song: "Canzone corretta",
			wrong_song: "Canzone sbagliata",
			error_marking_song: "Errore nella segnatura della canzone",
			bingo_finished: "Bingo completato",
			winner_team: "Squadra vincitrice",
			photo_screen: "Foto delle squadre",
			play: "Riproduci",
			pause: "Pausa",
			restart: "Reinicia",
			start_game: "INIZIA PARTITA",
			audio_permission_message: "Fai clic sul pulsante qui sotto per abilitare la riproduzione audio del gioco.",
			tab_muted_warning: "⚠️ La scheda del browser è disattivata",
			tab_muted_instructions: "Si prega di disattivare il silenzio della scheda del browser facendo clic sull'icona dell'altoparlante nella scheda per abilitare la riproduzione audio.",
			no_team_responding: "Nessun team ha risposto correttamente",
			final_ranking: "Classifica Finale"
		}
	},
	summaries: {
		description: "Scarica e gestisci riassunti e report di monitor",
		monitor_summaries: "Riassunti dei Monitor",
		download_monitor_summary: "Scarica Riassunto dei Monitor",
		select_month: "Seleziona Mese",
		select_month_description: "Scegli il mese per il quale desideri scaricare il report di riassunto dei monitor.",
		download: "Scarica",
		download_success: "Download Riuscito",
		download_success_detail: "Il riepilogo dei monitor per {month} è stato scaricato correttamente.",
		download_error: "Errore di download",
		download_error_detail: "Si è verificato un errore durante il download del riepilogo dei monitor. Per favore, riprova."
	},
	catalan: "Catalano",
	staff_page: {
		title: "Registri del personale",
		description: "Visualizza e gestisci i registri degli insegnanti di giochi per intervallo di date.",
		date_range: "Intervallo di date",
		select_year: "Anno",
		select_month: "Mese",
		all_months: "Tutti i mesi",
		filter_by_staff: "Filtra per personale",
		filter_by_accepted: "Stato accettato",
		all_staff: "Tutto il personale",
		filter_by_paid: "Stato di pagamento",
		all: "Tutto",
		paid: "Pagato",
		not_paid: "Non pagato",
		booking: "Prenotazione",
		booking_name: "Nome della prenotazione",
		date: "Data",
		staff: "Personale",
		salary: "Stipendio",
		accepted: "Accettato",
		responsible: "Responsabile",
		paid_status: "Stato di pagamento",
		comments: "Commenti",
		mark_selected_paid: "Contrassegna selezionato come pagato",
		mark_selected_not_paid: "Contrassegna selezionato come non pagato",
		mark_all_paid: "Contrassegna tutti come pagati",
		mark_all_not_paid: "Contrassegna tutti come non pagati",
		update_success: "Registri aggiornati con successo",
		update_error: "Errore durante l'aggiornamento dei registri. Per favore, riprova.",
		select_records: "Seleziona uno o più registri",
		loading: "Caricamento...",
		no_records: "Nessun registro trovato per il periodo selezionato.",
		records_updated: "{count} registro(i) aggiornato(i)",
		total_salary: "Salario totale",
		total_salary_to_be_paid: "Totale salario da pagare"
	},
	gm_activities_page: {
		description: "Consulta le tue attività, pagamenti e prenotazioni pendenti.",
		activities: "Attività",
		pending_reservation: "Prenotazione pendente"
	}
}